export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
    }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
}

export type AccordionWidget = Widget & {
  __typename?: 'AccordionWidget'
  content: Maybe<RichContent>
  id: Scalars['String']['output']
  query: Query
  title: Maybe<Scalars['String']['output']>
}

export type AccordionWidgetContainer = Widget & {
  __typename?: 'AccordionWidgetContainer'
  banners: Maybe<Array<Maybe<Widget>>>
  heading: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  title: Maybe<Scalars['String']['output']>
  titlePosition: Maybe<Scalars['String']['output']>
}

export type AlternateLink = {
  __typename?: 'AlternateLink'
  locale: Scalars['String']['output']
  url: Scalars['String']['output']
}

export enum AvailabilitySource {
  Dropship = 'DROPSHIP',
  Marketplace = 'MARKETPLACE',
  Warehouse = 'WAREHOUSE',
}

export type Brand = {
  __typename?: 'Brand'
  imageUrl: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  page: Maybe<BrandPage>
}

export type BrandCharacter = {
  __typename?: 'BrandCharacter'
  brands: Maybe<Array<Maybe<Brand>>>
  character: Maybe<Scalars['String']['output']>
}

export type BrandPage = {
  __typename?: 'BrandPage'
  path: Scalars['String']['output']
}

export type BrandsPageWidget = Widget & {
  __typename?: 'BrandsPageWidget'
  brands: Maybe<Array<Maybe<BrandCharacter>>>
  id: Scalars['String']['output']
  query: Query
}

export type Breadcrumb = {
  __typename?: 'Breadcrumb'
  displayName: Scalars['String']['output']
  pagePath: Scalars['String']['output']
  text: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type BuyNowPayLaterProvider = {
  __typename?: 'BuyNowPayLaterProvider'
  displayName: Scalars['String']['output']
  instalmentAmount: MoneyValue
  landingPageLink: Scalars['String']['output']
  numberOfInstalments: Scalars['Int']['output']
  providerName: Scalars['String']['output']
}

export type CheapestVariantInputs = {
  currency: Currency
  includeLinkedProducts: InputMaybe<Scalars['Boolean']['input']>
  shippingDestination: Country
}

export enum Country {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  An = 'AN',
  Ao = 'AO',
  Aq = 'AQ',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW',
}

export enum Currency {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Azn = 'AZN',
  Bam = 'BAM',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Byr = 'BYR',
  Cad = 'CAD',
  Chf = 'CHF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Czk = 'CZK',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Egp = 'EGP',
  Eur = 'EUR',
  Fjd = 'FJD',
  Gbp = 'GBP',
  Hkd = 'HKD',
  Hrk = 'HRK',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jpy = 'JPY',
  Kes = 'KES',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kzt = 'KZT',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Mad = 'MAD',
  Mkd = 'MKD',
  Mop = 'MOP',
  Mxn = 'MXN',
  Myr = 'MYR',
  Ngn = 'NGN',
  Nok = 'NOK',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pen = 'PEN',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Sar = 'SAR',
  Sek = 'SEK',
  Sgd = 'SGD',
  Thb = 'THB',
  Tnd = 'TND',
  Try = 'TRY',
  Twd = 'TWD',
  Uah = 'UAH',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vef = 'VEF',
  Vnd = 'VND',
  Wst = 'WST',
  Xcd = 'XCD',
  Zar = 'ZAR',
}

export type EmailReEngagementModal = Widget & {
  __typename?: 'EmailReEngagementModal'
  defaultImageHeight: Maybe<Scalars['String']['output']>
  defaultImageWidth: Maybe<Scalars['String']['output']>
  emailReEngagementBulletText1: Maybe<Scalars['String']['output']>
  emailReEngagementBulletText2: Maybe<Scalars['String']['output']>
  emailReEngagementBulletText3: Maybe<Scalars['String']['output']>
  emailReEngagementOptInDiscount: Maybe<Scalars['String']['output']>
  emailReEngagementTitleText: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imageAltText: Maybe<Scalars['String']['output']>
  imageLarge: Maybe<Scalars['String']['output']>
  imageMedium: Maybe<Scalars['String']['output']>
  imageSmall: Maybe<Scalars['String']['output']>
  picture: Maybe<GravityPicture>
  query: Query
}

export type Facet = {
  facetHeader: Scalars['String']['output']
  facetName: Scalars['String']['output']
}

export type FacetInput = {
  facetName: Scalars['String']['input']
  selections: Array<FacetSelectionInput>
}

export type FacetSelectionInput = {
  from: InputMaybe<Scalars['Float']['input']>
  optionName: InputMaybe<Scalars['String']['input']>
  to: InputMaybe<Scalars['Float']['input']>
}

export enum FetchPriority {
  Auto = 'AUTO',
  High = 'HIGH',
  Low = 'LOW',
}

export enum FulfilmentMethod {
  CollectInStore = 'COLLECT_IN_STORE',
  DeliverToStore = 'DELIVER_TO_STORE',
  HomeDelivery = 'HOME_DELIVERY',
}

export type GlobalAboutUsVideo = Widget & {
  __typename?: 'GlobalAboutUsVideo'
  buttonLink: Maybe<Scalars['String']['output']>
  buttonText: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  textBlock: Maybe<RichContent>
  title: Maybe<Scalars['String']['output']>
  transcript: Maybe<RichContent>
  videoTitle: Maybe<Scalars['String']['output']>
  videoURL: Maybe<Scalars['String']['output']>
}

export type GlobalAccreditationIconCollection = Widget & {
  __typename?: 'GlobalAccreditationIconCollection'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
}

export type GlobalBrandLogos = Widget & {
  __typename?: 'GlobalBrandLogos'
  brandLogosItemOneImageVariant: Maybe<Scalars['String']['output']>
  brandLogosItemOneImageVariantAlt: Maybe<Scalars['String']['output']>
  brandLogosItemOneVariantURL: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  isScrollable: Maybe<Scalars['String']['output']>
  itemFiveImage: Maybe<Scalars['String']['output']>
  itemFiveImageAlt: Maybe<Scalars['String']['output']>
  itemFiveURL: Maybe<Scalars['String']['output']>
  itemFourImage: Maybe<Scalars['String']['output']>
  itemFourImageAlt: Maybe<Scalars['String']['output']>
  itemFourURL: Maybe<Scalars['String']['output']>
  itemOneImage: Maybe<Scalars['String']['output']>
  itemOneImageAlt: Maybe<Scalars['String']['output']>
  itemOneURL: Maybe<Scalars['String']['output']>
  itemSixImage: Maybe<Scalars['String']['output']>
  itemSixImageAlt: Maybe<Scalars['String']['output']>
  itemSixURL: Maybe<Scalars['String']['output']>
  itemThreeImage: Maybe<Scalars['String']['output']>
  itemThreeImageAlt: Maybe<Scalars['String']['output']>
  itemThreeURL: Maybe<Scalars['String']['output']>
  itemTwoImage: Maybe<Scalars['String']['output']>
  itemTwoImageAlt: Maybe<Scalars['String']['output']>
  itemTwoURL: Maybe<Scalars['String']['output']>
  query: Query
  title: Maybe<Scalars['String']['output']>
  titleAlign: Maybe<Scalars['String']['output']>
}

export type GlobalBuyingRightNow = Widget & {
  __typename?: 'GlobalBuyingRightNow'
  id: Scalars['String']['output']
  productBlockFour: Maybe<ProductBlock>
  productBlockOne: Maybe<ProductBlock>
  productBlockThree: Maybe<ProductBlock>
  productBlockTwo: Maybe<ProductBlock>
  productTextFour: Maybe<Scalars['String']['output']>
  productTextOne: Maybe<Scalars['String']['output']>
  productTextThree: Maybe<Scalars['String']['output']>
  productTextTwo: Maybe<Scalars['String']['output']>
  query: Query
  title: Maybe<Scalars['String']['output']>
}

export type GlobalBuyingRightNowManualProductUrl = Widget & {
  __typename?: 'GlobalBuyingRightNowManualProductURL'
  id: Scalars['String']['output']
  productBlockFour: Maybe<ProductBlock>
  productBlockOne: Maybe<ProductBlock>
  productBlockThree: Maybe<ProductBlock>
  productBlockTwo: Maybe<ProductBlock>
  query: Query
  title: Maybe<Scalars['String']['output']>
}

export type GlobalCardScrollerCard = Widget & {
  __typename?: 'GlobalCardScrollerCard'
  altText: Maybe<Scalars['String']['output']>
  buttonText: Maybe<Scalars['String']['output']>
  colorOfText: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  image: Maybe<Scalars['String']['output']>
  picture: Maybe<GravityPicture>
  query: Query
  subtitle: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  url: Maybe<Scalars['String']['output']>
  verticalPositionOfText: Maybe<Scalars['String']['output']>
}

export type GlobalCardScrollerSet = Widget & {
  __typename?: 'GlobalCardScrollerSet'
  banners: Maybe<Array<Maybe<Widget>>>
  cardStyle: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  title: Maybe<Scalars['String']['output']>
}

export type GlobalDispatchAndDateCountdownWidget = Widget & {
  __typename?: 'GlobalDispatchAndDateCountdownWidget'
  countDownEndDay: Maybe<Scalars['String']['output']>
  countDownEndHour: Maybe<Scalars['Int']['output']>
  countDownEndMinutes: Maybe<Scalars['Int']['output']>
  countDownEndMonth: Maybe<Scalars['String']['output']>
  countDownEndSeconds: Maybe<Scalars['Int']['output']>
  countDownEndYear: Maybe<Scalars['String']['output']>
  countDownSubTitle: Maybe<Scalars['String']['output']>
  countDownTitle: Maybe<Scalars['String']['output']>
  daysTitle: Maybe<Scalars['String']['output']>
  decrement: Maybe<Scalars['Int']['output']>
  defaultNextDayDeliveryCutoff: Maybe<Scalars['Int']['output']>
  direction: Maybe<Scalars['String']['output']>
  dispatchIcon: Maybe<Scalars['String']['output']>
  dispatchTimeForFriday: Maybe<Scalars['Int']['output']>
  dispatchTimeForMonday: Maybe<Scalars['Int']['output']>
  dispatchTimeForSaturday: Maybe<Scalars['Int']['output']>
  dispatchTimeForSunday: Maybe<Scalars['Int']['output']>
  dispatchTimeForThursday: Maybe<Scalars['Int']['output']>
  dispatchTimeForTuesday: Maybe<Scalars['Int']['output']>
  dispatchTimeForWednesday: Maybe<Scalars['Int']['output']>
  dispatchTimer: Maybe<Scalars['String']['output']>
  hoursTitle: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  linkUrl: Maybe<Scalars['String']['output']>
  minutesTitle: Maybe<Scalars['String']['output']>
  query: Query
  removeOnEnd: Maybe<Scalars['String']['output']>
  secondsTitle: Maybe<Scalars['String']['output']>
  separator: Maybe<Scalars['String']['output']>
  showTimer: Maybe<Scalars['String']['output']>
  size: Maybe<Scalars['String']['output']>
  textAlignment: Maybe<Scalars['String']['output']>
  useLocal: Maybe<Scalars['String']['output']>
  weeksTitle: Maybe<Scalars['String']['output']>
}

export type GlobalEditorialWithFeature = Widget & {
  __typename?: 'GlobalEditorialWithFeature'
  CTAFeatured: Maybe<Scalars['String']['output']>
  CTAItemOne: Maybe<Scalars['String']['output']>
  CTAItemTwo: Maybe<Scalars['String']['output']>
  altItemTwo: Maybe<Scalars['String']['output']>
  altTextFeatured: Maybe<Scalars['String']['output']>
  altTextItemOne: Maybe<Scalars['String']['output']>
  description: Maybe<Scalars['String']['output']>
  descriptionFeatured: Maybe<Scalars['String']['output']>
  descriptionItemOne: Maybe<Scalars['String']['output']>
  descriptionItemTwo: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imageFeaturedLarge: Maybe<Scalars['String']['output']>
  imageFeaturedSmall: Maybe<Scalars['String']['output']>
  imageOneLarge: Maybe<Scalars['String']['output']>
  imageOneSmall: Maybe<Scalars['String']['output']>
  imageTwoLarge: Maybe<Scalars['String']['output']>
  imageTwoSmall: Maybe<Scalars['String']['output']>
  linkFeatured: Maybe<Scalars['String']['output']>
  linkItemOne: Maybe<Scalars['String']['output']>
  linkItemTwo: Maybe<Scalars['String']['output']>
  pictures: Maybe<GlobalEditorialWithFeaturePictures>
  query: Query
  title: Maybe<Scalars['String']['output']>
  titleFeatured: Maybe<Scalars['String']['output']>
  titleItemOne: Maybe<Scalars['String']['output']>
  titleItemTwo: Maybe<Scalars['String']['output']>
}

export type GlobalEditorialWithFeaturePictures = {
  __typename?: 'GlobalEditorialWithFeaturePictures'
  featuredPicture: Maybe<GravityPicture>
  pictureOne: Maybe<GravityPicture>
  pictureTwo: Maybe<GravityPicture>
}

export type GlobalFooterAccreditationIcons = Widget & {
  __typename?: 'GlobalFooterAccreditationIcons'
  Image2Alt: Maybe<Scalars['String']['output']>
  Image3Alt: Maybe<Scalars['String']['output']>
  Image3Href: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  image1: Maybe<Scalars['String']['output']>
  image1Alt: Maybe<Scalars['String']['output']>
  image1Href: Maybe<Scalars['String']['output']>
  image2: Maybe<Scalars['String']['output']>
  image2Href: Maybe<Scalars['String']['output']>
  image3: Maybe<Scalars['String']['output']>
  query: Query
}

export type GlobalFooterContactUs = Widget & {
  __typename?: 'GlobalFooterContactUs'
  id: Scalars['String']['output']
  line1: Maybe<Scalars['String']['output']>
  line2: Maybe<Scalars['String']['output']>
  line3: Maybe<Scalars['String']['output']>
  line4: Maybe<Scalars['String']['output']>
  line5: Maybe<Scalars['String']['output']>
  line6: Maybe<Scalars['String']['output']>
  line7: Maybe<Scalars['String']['output']>
  line8: Maybe<Scalars['String']['output']>
  line9: Maybe<Scalars['String']['output']>
  line10: Maybe<Scalars['String']['output']>
  query: Query
  title: Maybe<Scalars['String']['output']>
}

export type GlobalFourBestSellers = Widget & {
  __typename?: 'GlobalFourBestSellers'
  ProductFourButtonText: Maybe<Scalars['String']['output']>
  ProductOneButtonText: Maybe<Scalars['String']['output']>
  ProductThreeButtonText: Maybe<Scalars['String']['output']>
  ProductTwoButtonText: Maybe<Scalars['String']['output']>
  Title: Maybe<Scalars['String']['output']>
  disableTitle: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  productBlockFour: Maybe<ProductBlock>
  productBlockOne: Maybe<ProductBlock>
  productBlockThree: Maybe<ProductBlock>
  productBlockTwo: Maybe<ProductBlock>
  query: Query
}

export type GlobalFourButtonLink = Widget & {
  __typename?: 'GlobalFourButtonLink'
  buttonTextFour: Maybe<Scalars['String']['output']>
  buttonTextOne: Maybe<Scalars['String']['output']>
  buttonTextThree: Maybe<Scalars['String']['output']>
  buttonTextTwo: Maybe<Scalars['String']['output']>
  buttonUrlFour: Maybe<Scalars['String']['output']>
  buttonUrlOne: Maybe<Scalars['String']['output']>
  buttonUrlThree: Maybe<Scalars['String']['output']>
  buttonUrlTwo: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
}

export type GlobalFourItemEditorial = Widget & {
  __typename?: 'GlobalFourItemEditorial'
  altItemFour: Maybe<Scalars['String']['output']>
  altItemOne: Maybe<Scalars['String']['output']>
  altItemThree: Maybe<Scalars['String']['output']>
  altItemTwo: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  itemFourCTA: Maybe<Scalars['String']['output']>
  itemFourDescription: Maybe<Scalars['String']['output']>
  itemFourImage: Maybe<Scalars['String']['output']>
  itemFourSubtitle: Maybe<Scalars['String']['output']>
  itemFourTitle: Maybe<Scalars['String']['output']>
  itemFourUrl: Maybe<Scalars['String']['output']>
  itemOneCTA: Maybe<Scalars['String']['output']>
  itemOneDescription: Maybe<Scalars['String']['output']>
  itemOneImage: Maybe<Scalars['String']['output']>
  itemOneSubtitle: Maybe<Scalars['String']['output']>
  itemOneTitle: Maybe<Scalars['String']['output']>
  itemOneUrl: Maybe<Scalars['String']['output']>
  itemThreeCTA: Maybe<Scalars['String']['output']>
  itemThreeDescription: Maybe<Scalars['String']['output']>
  itemThreeImage: Maybe<Scalars['String']['output']>
  itemThreeSubtitle: Maybe<Scalars['String']['output']>
  itemThreeTitle: Maybe<Scalars['String']['output']>
  itemThreeUrl: Maybe<Scalars['String']['output']>
  itemTwoCTA: Maybe<Scalars['String']['output']>
  itemTwoDescription: Maybe<Scalars['String']['output']>
  itemTwoImage: Maybe<Scalars['String']['output']>
  itemTwoSubtitle: Maybe<Scalars['String']['output']>
  itemTwoTitle: Maybe<Scalars['String']['output']>
  itemTwoUrl: Maybe<Scalars['String']['output']>
  itemsCTAAlignment: Maybe<Scalars['String']['output']>
  noWrapItems: Maybe<Scalars['String']['output']>
  pictures: Maybe<GlobalFourItemEditorialPictures>
  query: Query
  styleModifier: Maybe<Scalars['String']['output']>
  textAlignment: Maybe<Scalars['String']['output']>
  widgetLink: Maybe<Scalars['String']['output']>
  widgetLinkText: Maybe<Scalars['String']['output']>
  widgetSubtitle: Maybe<Scalars['String']['output']>
  widgetTitle: Maybe<Scalars['String']['output']>
}

export type GlobalFourItemEditorialPictures = {
  __typename?: 'GlobalFourItemEditorialPictures'
  pictureFour: Maybe<GravityPicture>
  pictureOne: Maybe<GravityPicture>
  pictureThree: Maybe<GravityPicture>
  pictureTwo: Maybe<GravityPicture>
}

export type GlobalGeneralImageBanner = Widget & {
  __typename?: 'GlobalGeneralImageBanner'
  id: Scalars['String']['output']
  imageAltText: Maybe<Scalars['String']['output']>
  largeImage: Maybe<Scalars['String']['output']>
  linkUrl: Maybe<Scalars['String']['output']>
  mediumImage: Maybe<Scalars['String']['output']>
  picture: Maybe<GravityPicture>
  query: Query
  smallImage: Maybe<Scalars['String']['output']>
}

export type GlobalHelpCentreAccordion = Widget & {
  __typename?: 'GlobalHelpCentreAccordion'
  accordionContent: Maybe<RichContent>
  accordionHeading: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
}

export type GlobalHelpCentreAccordion2 = Widget & {
  __typename?: 'GlobalHelpCentreAccordion2'
  accordionContent: Maybe<RichContent>
  accordionHeading: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
}

export type GlobalHelpCentreAccordionCollection = Widget & {
  __typename?: 'GlobalHelpCentreAccordionCollection'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
  title: Maybe<Scalars['String']['output']>
}

export type GlobalHelpCentreCollection = Widget & {
  __typename?: 'GlobalHelpCentreCollection'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
}

export type GlobalHeroCtaBanner = Widget & {
  __typename?: 'GlobalHeroCTABanner'
  altTextImg: Maybe<Scalars['String']['output']>
  buttonOne: Maybe<Scalars['String']['output']>
  buttonOneLink: Maybe<Scalars['String']['output']>
  buttonTwo: Maybe<Scalars['String']['output']>
  buttonTwoLink: Maybe<Scalars['String']['output']>
  headline: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imageDesktop: Maybe<Scalars['String']['output']>
  imageExtraSmall: Maybe<Scalars['String']['output']>
  imageMedium: Maybe<Scalars['String']['output']>
  imageSmall: Maybe<Scalars['String']['output']>
  query: Query
  subtitle: Maybe<Scalars['String']['output']>
}

export type GlobalImageCard = Widget & {
  __typename?: 'GlobalImageCard'
  altText: Maybe<Scalars['String']['output']>
  buttonText: Maybe<Scalars['String']['output']>
  colorOfText: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  image: Maybe<Scalars['String']['output']>
  noBorder: Maybe<Scalars['Boolean']['output']>
  openLinksInNewTab: Maybe<Scalars['String']['output']>
  picture: Maybe<GravityPicture>
  query: Query
  subtitle: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  url: Maybe<Scalars['String']['output']>
  verticalPositionOfText: Maybe<Scalars['String']['output']>
}

export type GlobalImageCardSet = Widget & {
  __typename?: 'GlobalImageCardSet'
  banners: Maybe<Array<Maybe<Widget>>>
  cardStyle: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  noBorder: Maybe<Scalars['Boolean']['output']>
  query: Query
  stackCardsOnMobile: Maybe<Scalars['Boolean']['output']>
  title: Maybe<Scalars['String']['output']>
}

export type GlobalMultiButton = Widget & {
  __typename?: 'GlobalMultiButton'
  id: Scalars['String']['output']
  multiButtonWidget_buttonStyle: Maybe<Scalars['String']['output']>
  multiButtonWidget_itemFiveCTAText: Maybe<Scalars['String']['output']>
  multiButtonWidget_itemFiveURL: Maybe<Scalars['String']['output']>
  multiButtonWidget_itemFourCTAText: Maybe<Scalars['String']['output']>
  multiButtonWidget_itemFourURL: Maybe<Scalars['String']['output']>
  multiButtonWidget_itemOneCTAText: Maybe<Scalars['String']['output']>
  multiButtonWidget_itemOneURL: Maybe<Scalars['String']['output']>
  multiButtonWidget_itemSixCTAText: Maybe<Scalars['String']['output']>
  multiButtonWidget_itemSixURL: Maybe<Scalars['String']['output']>
  multiButtonWidget_itemThreeCTAText: Maybe<Scalars['String']['output']>
  multiButtonWidget_itemThreeURL: Maybe<Scalars['String']['output']>
  multiButtonWidget_itemTwoCTAText: Maybe<Scalars['String']['output']>
  multiButtonWidget_itemTwoURL: Maybe<Scalars['String']['output']>
  query: Query
}

export type GlobalPrimaryBanner = Widget & {
  __typename?: 'GlobalPrimaryBanner'
  altImageLarge: Maybe<Scalars['String']['output']>
  altLogoPng: Maybe<Scalars['String']['output']>
  bannerURL: Maybe<Scalars['String']['output']>
  contentAlign: Maybe<Scalars['String']['output']>
  contentBoxPosition: Maybe<Scalars['String']['output']>
  contentTheme: Maybe<Scalars['String']['output']>
  ctaOne: Maybe<Scalars['String']['output']>
  ctaOneAriaLabel: Maybe<Scalars['String']['output']>
  ctaOneURL: Maybe<Scalars['String']['output']>
  ctaTwo: Maybe<Scalars['String']['output']>
  ctaTwoAriaLabel: Maybe<Scalars['String']['output']>
  ctaTwoURL: Maybe<Scalars['String']['output']>
  hasMargin: Maybe<Scalars['String']['output']>
  headline: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imageLarge: Maybe<Scalars['String']['output']>
  imageMedium: Maybe<Scalars['String']['output']>
  imageSmall: Maybe<Scalars['String']['output']>
  logopngImageBG: Maybe<Scalars['String']['output']>
  logopngWhiteBG: Maybe<Scalars['String']['output']>
  picture: Maybe<GravityPicture>
  query: Query
  subtitle: Maybe<Scalars['String']['output']>
  useH1: Maybe<Scalars['String']['output']>
}

export type GlobalPrimaryBannerWithList = Widget & {
  __typename?: 'GlobalPrimaryBannerWithList'
  altImageLarge: Maybe<Scalars['String']['output']>
  altLogoPng: Maybe<Scalars['String']['output']>
  bannerURL: Maybe<Scalars['String']['output']>
  contentAlign: Maybe<Scalars['String']['output']>
  contentBoxPosition: Maybe<Scalars['String']['output']>
  contentTheme: Maybe<Scalars['String']['output']>
  ctaOne: Maybe<Scalars['String']['output']>
  ctaOneAriaLabel: Maybe<Scalars['String']['output']>
  ctaOneURL: Maybe<Scalars['String']['output']>
  ctaTwo: Maybe<Scalars['String']['output']>
  ctaTwoAriaLabel: Maybe<Scalars['String']['output']>
  ctaTwoURL: Maybe<Scalars['String']['output']>
  headline: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imageLarge: Maybe<Scalars['String']['output']>
  imageMedium: Maybe<Scalars['String']['output']>
  imageSmall: Maybe<Scalars['String']['output']>
  listBrowserSection: Maybe<Scalars['String']['output']>
  logopngImageBG: Maybe<Scalars['String']['output']>
  logopngWhiteBG: Maybe<Scalars['String']['output']>
  picture: Maybe<GravityPicture>
  query: Query
  subtitle: Maybe<Scalars['String']['output']>
}

export type GlobalPrimaryBannerWithTextOverlay = Widget & {
  __typename?: 'GlobalPrimaryBannerWithTextOverlay'
  altImageLarge: Maybe<Scalars['String']['output']>
  altLogoPng: Maybe<Scalars['String']['output']>
  bannerURL: Maybe<Scalars['String']['output']>
  contentAlign: Maybe<Scalars['String']['output']>
  contentBoxPosition: Maybe<Scalars['String']['output']>
  contentTheme: Maybe<Scalars['String']['output']>
  ctaOne: Maybe<Scalars['String']['output']>
  ctaOneAriaLabel: Maybe<Scalars['String']['output']>
  ctaOneURL: Maybe<Scalars['String']['output']>
  ctaTwo: Maybe<Scalars['String']['output']>
  ctaTwoAriaLabel: Maybe<Scalars['String']['output']>
  ctaTwoURL: Maybe<Scalars['String']['output']>
  hasMargin: Maybe<Scalars['String']['output']>
  headline: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imageLarge: Maybe<Scalars['String']['output']>
  imageMedium: Maybe<Scalars['String']['output']>
  imageSmall: Maybe<Scalars['String']['output']>
  logopngImageBG: Maybe<Scalars['String']['output']>
  logopngWhiteBG: Maybe<Scalars['String']['output']>
  openInTabOne: Maybe<Scalars['String']['output']>
  openInTabTwo: Maybe<Scalars['String']['output']>
  picture: Maybe<GravityPicture>
  query: Query
  subtitle: Maybe<Scalars['String']['output']>
  useH1: Maybe<Scalars['String']['output']>
}

export type GlobalProductCardScroller = Widget & {
  __typename?: 'GlobalProductCardScroller'
  GlobalProductCardScrollerVariants: Maybe<ProductVariant>
  hasArrows: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  /** @deprecated Use the field with type WidgetProductItem, name should be 'paramName'+New */
  productSkuList: Maybe<Array<Maybe<ProductVariant>>>
  productSkuListNew: Maybe<Array<Maybe<WidgetProductItem>>>
  query: Query
  title: Maybe<Scalars['String']['output']>
}

export type GlobalReferral3StepGuide = Widget & {
  __typename?: 'GlobalReferral3StepGuide'
  id: Scalars['String']['output']
  query: Query
  smallprint: Maybe<Scalars['String']['output']>
  step1icon: Maybe<Scalars['String']['output']>
  step1text: Maybe<Scalars['String']['output']>
  step1title: Maybe<Scalars['String']['output']>
  step2icon: Maybe<Scalars['String']['output']>
  step2text: Maybe<Scalars['String']['output']>
  step2title: Maybe<Scalars['String']['output']>
  step3icon: Maybe<Scalars['String']['output']>
  step3text: Maybe<Scalars['String']['output']>
  step3title: Maybe<Scalars['String']['output']>
  subtitle: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
}

export type GlobalScalableLogos = Widget & {
  __typename?: 'GlobalScalableLogos'
  altTextFive: Maybe<Scalars['String']['output']>
  altTextFour: Maybe<Scalars['String']['output']>
  altTextOne: Maybe<Scalars['String']['output']>
  altTextSix: Maybe<Scalars['String']['output']>
  altTextThree: Maybe<Scalars['String']['output']>
  altTextTwo: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imagePathFive: Maybe<Scalars['String']['output']>
  imagePathFour: Maybe<Scalars['String']['output']>
  imagePathOne: Maybe<Scalars['String']['output']>
  imagePathSix: Maybe<Scalars['String']['output']>
  imagePathThree: Maybe<Scalars['String']['output']>
  imagePathTwo: Maybe<Scalars['String']['output']>
  query: Query
  titleFive: Maybe<Scalars['String']['output']>
  titleFour: Maybe<Scalars['String']['output']>
  titleOne: Maybe<Scalars['String']['output']>
  titleSix: Maybe<Scalars['String']['output']>
  titleThree: Maybe<Scalars['String']['output']>
  titleTwo: Maybe<Scalars['String']['output']>
  urlFive: Maybe<Scalars['String']['output']>
  urlFour: Maybe<Scalars['String']['output']>
  urlOne: Maybe<Scalars['String']['output']>
  urlSix: Maybe<Scalars['String']['output']>
  urlThree: Maybe<Scalars['String']['output']>
  urlTwo: Maybe<Scalars['String']['output']>
}

export type GlobalSectionPeek = Widget & {
  __typename?: 'GlobalSectionPeek'
  FloatOfProducts: Maybe<Scalars['Int']['output']>
  id: Scalars['String']['output']
  productList: Maybe<ProductList>
  qubitPlacementId: Maybe<Scalars['String']['output']>
  query: Query
  title: Maybe<Scalars['String']['output']>
  titleAlign: Maybe<Scalars['String']['output']>
  url: Maybe<Scalars['String']['output']>
}

export type GlobalSetAndromeda = Widget & {
  __typename?: 'GlobalSetAndromeda'
  banners: Maybe<Array<Maybe<Widget>>>
  columns: Maybe<Scalars['Int']['output']>
  id: Scalars['String']['output']
  query: Query
}

export type GlobalSimpleTextCtaWidget = Widget & {
  __typename?: 'GlobalSimpleTextCTAWidget'
  id: Scalars['String']['output']
  itemOneCTAText: Maybe<Scalars['String']['output']>
  itemOneURL: Maybe<Scalars['String']['output']>
  query: Query
  text: Maybe<Scalars['String']['output']>
  textAlign: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
}

export type GlobalSixItemCategories = Widget & {
  __typename?: 'GlobalSixItemCategories'
  altItemFive: Maybe<Scalars['String']['output']>
  altItemFour: Maybe<Scalars['String']['output']>
  altItemOne: Maybe<Scalars['String']['output']>
  altItemSix: Maybe<Scalars['String']['output']>
  altItemThree: Maybe<Scalars['String']['output']>
  altItemTwo: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  itemCTAAlign: Maybe<Scalars['String']['output']>
  itemFiveCTA: Maybe<Scalars['String']['output']>
  itemFiveImage: Maybe<Scalars['String']['output']>
  itemFiveLink: Maybe<Scalars['String']['output']>
  itemFiveTitle: Maybe<Scalars['String']['output']>
  itemFourCTA: Maybe<Scalars['String']['output']>
  itemFourImage: Maybe<Scalars['String']['output']>
  itemFourLink: Maybe<Scalars['String']['output']>
  itemFourTitle: Maybe<Scalars['String']['output']>
  itemOneCTA: Maybe<Scalars['String']['output']>
  itemOneImage: Maybe<Scalars['String']['output']>
  itemOneLink: Maybe<Scalars['String']['output']>
  itemOneTitle: Maybe<Scalars['String']['output']>
  itemSixCTA: Maybe<Scalars['String']['output']>
  itemSixImage: Maybe<Scalars['String']['output']>
  itemSixLink: Maybe<Scalars['String']['output']>
  itemSixTitle: Maybe<Scalars['String']['output']>
  itemThreeCTA: Maybe<Scalars['String']['output']>
  itemThreeImage: Maybe<Scalars['String']['output']>
  itemThreeLink: Maybe<Scalars['String']['output']>
  itemThreeTitle: Maybe<Scalars['String']['output']>
  itemTitleAlign: Maybe<Scalars['String']['output']>
  itemTwoCTA: Maybe<Scalars['String']['output']>
  itemTwoImage: Maybe<Scalars['String']['output']>
  itemTwoLink: Maybe<Scalars['String']['output']>
  itemTwoTitle: Maybe<Scalars['String']['output']>
  pictures: Maybe<GlobalSixItemCategoriesPictures>
  query: Query
  title: Maybe<Scalars['String']['output']>
}

export type GlobalSixItemCategoriesPictures = {
  __typename?: 'GlobalSixItemCategoriesPictures'
  pictureFive: Maybe<GravityPicture>
  pictureFour: Maybe<GravityPicture>
  pictureOne: Maybe<GravityPicture>
  pictureSix: Maybe<GravityPicture>
  pictureThree: Maybe<GravityPicture>
  pictureTwo: Maybe<GravityPicture>
}

export type GlobalSocialIcon = Widget & {
  __typename?: 'GlobalSocialIcon'
  icon: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  url: Maybe<Scalars['String']['output']>
}

export type GlobalSocialIconCollection = Widget & {
  __typename?: 'GlobalSocialIconCollection'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
  title: Maybe<Scalars['String']['output']>
}

export type GlobalSocialIconCollectionv2 = Widget & {
  __typename?: 'GlobalSocialIconCollectionv2'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
  title: Maybe<Scalars['String']['output']>
}

export type GlobalSocialIconv2 = Widget & {
  __typename?: 'GlobalSocialIconv2'
  icon: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  url: Maybe<Scalars['String']['output']>
}

export type GlobalStripBanner = Widget & {
  __typename?: 'GlobalStripBanner'
  CTAAlignment: Maybe<Scalars['String']['output']>
  hideDefaultBanner: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  stripBannerText: Maybe<Scalars['String']['output']>
  stripBannerTextAccount: Maybe<Scalars['String']['output']>
  stripBannerTextBasket: Maybe<Scalars['String']['output']>
  stripBannerTextHomepage: Maybe<Scalars['String']['output']>
  stripBannerTextPDP: Maybe<Scalars['String']['output']>
  stripBannerTextPLP: Maybe<Scalars['String']['output']>
  stripBannerURL: Maybe<Scalars['String']['output']>
  stripBannerURLAccount: Maybe<Scalars['String']['output']>
  stripBannerURLBasket: Maybe<Scalars['String']['output']>
  stripBannerURLHomepage: Maybe<Scalars['String']['output']>
  stripBannerURLPDP: Maybe<Scalars['String']['output']>
  stripBannerURLPLP: Maybe<Scalars['String']['output']>
}

export type GlobalSubscriptionOptions = Widget & {
  __typename?: 'GlobalSubscriptionOptions'
  id: Scalars['String']['output']
  query: Query
  subscriptionOptionsRibbonMessage: Maybe<Scalars['String']['output']>
  subscriptionOptionsShowRibbon: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuFour: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuFourCTAText: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuFourDeliveryInfo: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuFourImage: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuFourPrice: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuFourPriceAppend: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuFourSaveMessage: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuFourTitle: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuFourUspMessage: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuOne: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuOneCTAText: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuOneDeliveryInfo: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuOneImage: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuOnePrice: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuOnePriceAppend: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuOneSaveMessage: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuOneTitle: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuOneUspMessage: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuThree: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuThreeCTAText: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuThreeDeliveryInfo: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuThreeImage: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuThreePrice: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuThreePriceAppend: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuThreeSaveMessage: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuThreeTitle: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuThreeUspMessage: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuTwo: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuTwoCTAText: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuTwoDeliveryInfo: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuTwoImage: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuTwoPrice: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuTwoPriceAppend: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuTwoSaveMessage: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuTwoTitle: Maybe<Scalars['String']['output']>
  subscriptionOptionsSkuTwoUspMessage: Maybe<Scalars['String']['output']>
}

export type GlobalTabbedWidgetSet = Widget & {
  __typename?: 'GlobalTabbedWidgetSet'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
  responsiveProductTabsTitle: Scalars['String']['output']
  tabbedWidgetSetSubTitle: Maybe<Scalars['String']['output']>
  tabbedWidgetSetTitle: Maybe<Scalars['String']['output']>
  tabbedWidgetTabTitle_1: Maybe<Scalars['String']['output']>
  tabbedWidgetTabTitle_2: Maybe<Scalars['String']['output']>
}

export type GlobalThreeItemEditorial = Widget & {
  __typename?: 'GlobalThreeItemEditorial'
  altItemOne: Maybe<Scalars['String']['output']>
  altItemThree: Maybe<Scalars['String']['output']>
  altItemTwo: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  itemOneCTAText: Maybe<Scalars['String']['output']>
  itemOneDescription: Maybe<Scalars['String']['output']>
  itemOneImage: Maybe<Scalars['String']['output']>
  itemOneSubtitle: Maybe<Scalars['String']['output']>
  itemOneTitle: Maybe<Scalars['String']['output']>
  itemOneUrl: Maybe<Scalars['String']['output']>
  itemOne_secondaryCTAText: Maybe<Scalars['String']['output']>
  itemOne_secondaryCTAUrl: Maybe<Scalars['String']['output']>
  itemThreeCTAText: Maybe<Scalars['String']['output']>
  itemThreeDescription: Maybe<Scalars['String']['output']>
  itemThreeImage: Maybe<Scalars['String']['output']>
  itemThreeSubtitle: Maybe<Scalars['String']['output']>
  itemThreeTitle: Maybe<Scalars['String']['output']>
  itemThreeUrl: Maybe<Scalars['String']['output']>
  itemThree_secondaryCTAText: Maybe<Scalars['String']['output']>
  itemThree_secondaryCTAUrl: Maybe<Scalars['String']['output']>
  itemTwoCTAText: Maybe<Scalars['String']['output']>
  itemTwoDescription: Maybe<Scalars['String']['output']>
  itemTwoImage: Maybe<Scalars['String']['output']>
  itemTwoSubtitle: Maybe<Scalars['String']['output']>
  itemTwoTitle: Maybe<Scalars['String']['output']>
  itemTwoUrl: Maybe<Scalars['String']['output']>
  itemTwo_secondaryCTAText: Maybe<Scalars['String']['output']>
  itemTwo_secondaryCTAUrl: Maybe<Scalars['String']['output']>
  pictures: Maybe<GlobalThreeItemEditorialPictures>
  query: Query
  threeItemItemOneAltTextVariant: Maybe<Scalars['String']['output']>
  threeItemItemOneCTATextVariant: Maybe<Scalars['String']['output']>
  threeItemItemOneDescriptionVariant: Maybe<Scalars['String']['output']>
  threeItemItemOneImageVariant: Maybe<Scalars['String']['output']>
  threeItemItemOneSubtitleVariant: Maybe<Scalars['String']['output']>
  threeItemItemOneTitleVariant: Maybe<Scalars['String']['output']>
  threeItemItemOneVariantUrl: Maybe<Scalars['String']['output']>
  useCircularImages: Maybe<Scalars['String']['output']>
  widgetHeadingSize: Maybe<Scalars['String']['output']>
  widgetSubtitle: Maybe<Scalars['String']['output']>
  widgetTitle: Maybe<Scalars['String']['output']>
}

export type GlobalThreeItemEditorialPictures = {
  __typename?: 'GlobalThreeItemEditorialPictures'
  pictureOne: Maybe<GravityPicture>
  pictureThree: Maybe<GravityPicture>
  pictureTwo: Maybe<GravityPicture>
}

export type GlobalThreeItemEditorialSubtitleBg = Widget & {
  __typename?: 'GlobalThreeItemEditorialSubtitleBG'
  description: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  itemOneAltText: Maybe<Scalars['String']['output']>
  itemOneCTAText: Maybe<Scalars['String']['output']>
  itemOneDescription: Maybe<Scalars['String']['output']>
  itemOneImage: Maybe<Scalars['String']['output']>
  itemOneSubtitle: Maybe<Scalars['String']['output']>
  itemOneSubtitleBGColour: Maybe<Scalars['String']['output']>
  itemOneTitle: Maybe<Scalars['String']['output']>
  itemOneUrl: Maybe<Scalars['String']['output']>
  itemThreeAltText: Maybe<Scalars['String']['output']>
  itemThreeCTAText: Maybe<Scalars['String']['output']>
  itemThreeDescription: Maybe<Scalars['String']['output']>
  itemThreeImage: Maybe<Scalars['String']['output']>
  itemThreeSubtitle: Maybe<Scalars['String']['output']>
  itemThreeSubtitleBGColour: Maybe<Scalars['String']['output']>
  itemThreeTitle: Maybe<Scalars['String']['output']>
  itemThreeUrl: Maybe<Scalars['String']['output']>
  itemTwoAltText: Maybe<Scalars['String']['output']>
  itemTwoCTAText: Maybe<Scalars['String']['output']>
  itemTwoDescription: Maybe<Scalars['String']['output']>
  itemTwoImage: Maybe<Scalars['String']['output']>
  itemTwoSubtitle: Maybe<Scalars['String']['output']>
  itemTwoSubtitleBGColour: Maybe<Scalars['String']['output']>
  itemTwoTitle: Maybe<Scalars['String']['output']>
  itemTwoUrl: Maybe<Scalars['String']['output']>
  pictures: Maybe<GlobalThreeItemEditorialPictures>
  query: Query
  title: Maybe<Scalars['String']['output']>
}

export type GlobalTransformationSlider = Widget & {
  __typename?: 'GlobalTransformationSlider'
  afterImageAltText: Maybe<Scalars['String']['output']>
  afterImageLarge: Maybe<Scalars['String']['output']>
  afterImageMedium: Maybe<Scalars['String']['output']>
  afterImageSmall: Maybe<Scalars['String']['output']>
  beforeImageAltText: Maybe<Scalars['String']['output']>
  beforeImageLarge: Maybe<Scalars['String']['output']>
  beforeImageMedium: Maybe<Scalars['String']['output']>
  beforeImageSmall: Maybe<Scalars['String']['output']>
  dividingLineColor: Maybe<Scalars['String']['output']>
  dragButtonPosition: Maybe<Scalars['String']['output']>
  dragLinePosition: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  title: Maybe<Scalars['String']['output']>
  titlePosition: Maybe<Scalars['String']['output']>
}

export type GlobalTrendingHashtagBlock = Widget & {
  __typename?: 'GlobalTrendingHashtagBlock'
  hashtag: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  url: Maybe<Scalars['String']['output']>
}

export type GlobalTrendingHashtagCollection = Widget & {
  __typename?: 'GlobalTrendingHashtagCollection'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
}

export type GlobalTwoBestSellers = Widget & {
  __typename?: 'GlobalTwoBestSellers'
  ProductOneButtonText: Maybe<Scalars['String']['output']>
  ProductTwoButtonText: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  productBlockOne: Maybe<ProductBlock>
  productBlockTwo: Maybe<ProductBlock>
  query: Query
}

export type GlobalTwoItemEditorial = Widget & {
  __typename?: 'GlobalTwoItemEditorial'
  altItemOne: Maybe<Scalars['String']['output']>
  altItemTwo: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  itemOneCTAText: Maybe<Scalars['String']['output']>
  itemOneDescription: Maybe<Scalars['String']['output']>
  itemOneImage: Maybe<Scalars['String']['output']>
  itemOneTitle: Maybe<Scalars['String']['output']>
  itemOneURL: Maybe<Scalars['String']['output']>
  itemTwoCTAText: Maybe<Scalars['String']['output']>
  itemTwoDescription: Maybe<Scalars['String']['output']>
  itemTwoImage: Maybe<Scalars['String']['output']>
  itemTwoTitle: Maybe<Scalars['String']['output']>
  itemTwoURL: Maybe<Scalars['String']['output']>
  pictures: Maybe<GlobalTwoItemEditorialPictures>
  query: Query
  widgetSubtitle: Maybe<Scalars['String']['output']>
  widgetTitle: Maybe<Scalars['String']['output']>
}

export type GlobalTwoItemEditorialPictures = {
  __typename?: 'GlobalTwoItemEditorialPictures'
  pictureOne: Maybe<GravityPicture>
  pictureTwo: Maybe<GravityPicture>
}

export type GlobalTwoItemImageTextBlock = Widget & {
  __typename?: 'GlobalTwoItemImageTextBlock'
  backgroundColour: Maybe<Scalars['String']['output']>
  button2Text: Maybe<Scalars['String']['output']>
  button2Url: Maybe<Scalars['String']['output']>
  hasMargin: Maybe<Scalars['String']['output']>
  hasPadding: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imageAnnotationText: Maybe<Scalars['String']['output']>
  imageProductText: Maybe<Scalars['String']['output']>
  imageProductURL: Maybe<Scalars['String']['output']>
  itemAlign: Maybe<Scalars['String']['output']>
  itemAlt: Maybe<Scalars['String']['output']>
  itemButton: Maybe<Scalars['String']['output']>
  itemImage: Maybe<Scalars['String']['output']>
  itemImageSmall: Maybe<Scalars['String']['output']>
  itemText: Maybe<RichContent>
  itemTitle: Maybe<Scalars['String']['output']>
  itemURL: Maybe<Scalars['String']['output']>
  lightMode: Maybe<Scalars['String']['output']>
  query: Query
  textAlign: Maybe<Scalars['String']['output']>
  transcript: Maybe<RichContent>
  videoTitle: Maybe<Scalars['String']['output']>
  videoUrl: Maybe<Scalars['String']['output']>
}

export type GlobalTwoItemImageTextCta = Widget & {
  __typename?: 'GlobalTwoItemImageTextCTA'
  backgroundColour: Maybe<Scalars['String']['output']>
  contentTheme: Maybe<Scalars['String']['output']>
  hasMargin: Maybe<Scalars['String']['output']>
  hasPadding: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  itemOneCTAText: Maybe<Scalars['String']['output']>
  itemOneContentAlign: Maybe<Scalars['String']['output']>
  itemOneDescription: Maybe<Scalars['String']['output']>
  itemOneImage: Maybe<Scalars['String']['output']>
  itemOneImageAltText: Maybe<Scalars['String']['output']>
  itemOneImageSmall: Maybe<Scalars['String']['output']>
  itemOneTitle: Maybe<Scalars['String']['output']>
  itemOneURL: Maybe<Scalars['String']['output']>
  itemTwoCTAText: Maybe<Scalars['String']['output']>
  itemTwoContentAlign: Maybe<Scalars['String']['output']>
  itemTwoDescription: Maybe<Scalars['String']['output']>
  itemTwoImage: Maybe<Scalars['String']['output']>
  itemTwoImageAltText: Maybe<Scalars['String']['output']>
  itemTwoImageSmall: Maybe<Scalars['String']['output']>
  itemTwoTitle: Maybe<Scalars['String']['output']>
  itemTwoURL: Maybe<Scalars['String']['output']>
  query: Query
}

export type GlobalTwoItemImageTextCta3070 = Widget & {
  __typename?: 'GlobalTwoItemImageTextCTA3070'
  contentTheme: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  itemOneCTAText: Maybe<Scalars['String']['output']>
  itemOneContentAlign: Maybe<Scalars['String']['output']>
  itemOneDescription: Maybe<Scalars['String']['output']>
  itemOneImage: Maybe<Scalars['String']['output']>
  itemOneImageAltText: Maybe<Scalars['String']['output']>
  itemOneImageSmall: Maybe<Scalars['String']['output']>
  itemOneTitle: Maybe<Scalars['String']['output']>
  itemOneURL: Maybe<Scalars['String']['output']>
  itemTwoCTAText: Maybe<Scalars['String']['output']>
  itemTwoContentAlign: Maybe<Scalars['String']['output']>
  itemTwoDescription: Maybe<Scalars['String']['output']>
  itemTwoImage: Maybe<Scalars['String']['output']>
  itemTwoImageAltText: Maybe<Scalars['String']['output']>
  itemTwoImageSmall: Maybe<Scalars['String']['output']>
  itemTwoTitle: Maybe<Scalars['String']['output']>
  itemTwoURL: Maybe<Scalars['String']['output']>
  query: Query
}

export type GlobalUgcCarousel = Widget & {
  __typename?: 'GlobalUGCCarousel'
  category: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  tag: Maybe<Scalars['String']['output']>
  ugcSubText: Maybe<Scalars['String']['output']>
  ugcTitle: Maybe<Scalars['String']['output']>
}

export type GlobalVideoGallery = Widget & {
  __typename?: 'GlobalVideoGallery'
  id: Scalars['String']['output']
  itemFiveButtonLink: Maybe<Scalars['String']['output']>
  itemFiveCTA: Maybe<Scalars['String']['output']>
  itemFiveCdnPath: Maybe<Scalars['String']['output']>
  itemFiveImage: Maybe<Scalars['String']['output']>
  itemFiveImageAltText: Maybe<Scalars['String']['output']>
  itemFiveTitle: Maybe<Scalars['String']['output']>
  itemFiveTranscript: Maybe<RichContent>
  itemFiveVideoURL: Maybe<Scalars['String']['output']>
  itemFourButtonLink: Maybe<Scalars['String']['output']>
  itemFourCTA: Maybe<Scalars['String']['output']>
  itemFourCdnPath: Maybe<Scalars['String']['output']>
  itemFourImage: Maybe<Scalars['String']['output']>
  itemFourImageAltText: Maybe<Scalars['String']['output']>
  itemFourTitle: Maybe<Scalars['String']['output']>
  itemFourTranscript: Maybe<RichContent>
  itemFourVideoURL: Maybe<Scalars['String']['output']>
  itemOneButtonLink: Maybe<Scalars['String']['output']>
  itemOneCTA: Maybe<Scalars['String']['output']>
  itemOneCdnPath: Maybe<Scalars['String']['output']>
  itemOneImage: Maybe<Scalars['String']['output']>
  itemOneImageAltText: Maybe<Scalars['String']['output']>
  itemOneTitle: Maybe<Scalars['String']['output']>
  itemOneTranscript: Maybe<RichContent>
  itemOneVideoURL: Maybe<Scalars['String']['output']>
  itemSixButtonLink: Maybe<Scalars['String']['output']>
  itemSixCTA: Maybe<Scalars['String']['output']>
  itemSixCdnPath: Maybe<Scalars['String']['output']>
  itemSixImage: Maybe<Scalars['String']['output']>
  itemSixImageAltText: Maybe<Scalars['String']['output']>
  itemSixTitle: Maybe<Scalars['String']['output']>
  itemSixTranscript: Maybe<RichContent>
  itemSixVideoURL: Maybe<Scalars['String']['output']>
  itemThreeButtonLink: Maybe<Scalars['String']['output']>
  itemThreeCTA: Maybe<Scalars['String']['output']>
  itemThreeCdnPath: Maybe<Scalars['String']['output']>
  itemThreeImage: Maybe<Scalars['String']['output']>
  itemThreeImageAltText: Maybe<Scalars['String']['output']>
  itemThreeTitle: Maybe<Scalars['String']['output']>
  itemThreeTranscript: Maybe<RichContent>
  itemThreeVideoURL: Maybe<Scalars['String']['output']>
  itemTwoButtonLink: Maybe<Scalars['String']['output']>
  itemTwoCTA: Maybe<Scalars['String']['output']>
  itemTwoCdnPath: Maybe<Scalars['String']['output']>
  itemTwoImage: Maybe<Scalars['String']['output']>
  itemTwoImageAltText: Maybe<Scalars['String']['output']>
  itemTwoTitle: Maybe<Scalars['String']['output']>
  itemTwoTranscript: Maybe<RichContent>
  itemTwoVideoURL: Maybe<Scalars['String']['output']>
  query: Query
  textAlign: Maybe<Scalars['String']['output']>
  textBlock: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  useTitleHeadingLevel2: Maybe<Scalars['Boolean']['output']>
}

export type GlobalVideoHeroBannerWidget = Widget & {
  __typename?: 'GlobalVideoHeroBannerWidget'
  VideoPreviewImageTablet: Maybe<Scalars['String']['output']>
  autoplayVideo: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  muteVideo: Maybe<Scalars['String']['output']>
  query: Query
  transcript: Maybe<RichContent>
  videoAssetPathMp4: Maybe<Scalars['String']['output']>
  videoAssetPathWebm: Maybe<Scalars['String']['output']>
  videoCaptionPathVTT: Maybe<Scalars['String']['output']>
  videoHeroContentAlign: Maybe<Scalars['String']['output']>
  videoHeroContentBoxPosition: Maybe<Scalars['String']['output']>
  videoHeroContentTheme: Maybe<Scalars['String']['output']>
  videoHeroCtaOne: Maybe<Scalars['String']['output']>
  videoHeroCtaOneAriaLabel: Maybe<Scalars['String']['output']>
  videoHeroCtaOneURL: Maybe<Scalars['String']['output']>
  videoHeroCtaTwo: Maybe<Scalars['String']['output']>
  videoHeroCtaTwoAriaLabel: Maybe<Scalars['String']['output']>
  videoHeroCtaTwoURL: Maybe<Scalars['String']['output']>
  videoHeroHeadline: Maybe<Scalars['String']['output']>
  videoHeroSubtitle: Maybe<Scalars['String']['output']>
  videoHeroUseH1: Maybe<Scalars['String']['output']>
  videoPreviewImage: Maybe<Scalars['String']['output']>
  videoPreviewImageMobile: Maybe<Scalars['String']['output']>
  videoTitle: Maybe<Scalars['String']['output']>
}

export type GlobalVideoTextImageCta = Widget & {
  __typename?: 'GlobalVideoTextImageCTA'
  id: Scalars['String']['output']
  itemCTA: Maybe<Scalars['String']['output']>
  itemCTALink: Maybe<Scalars['String']['output']>
  itemDescription: Maybe<Scalars['String']['output']>
  itemImage: Maybe<Scalars['String']['output']>
  itemImageLink: Maybe<Scalars['String']['output']>
  query: Query
  videoUrl: Maybe<Scalars['String']['output']>
  widgetTitle: Maybe<Scalars['String']['output']>
}

export type GlobalWaitListSignUpFormResponses = Widget & {
  __typename?: 'GlobalWaitListSignUpFormResponses'
  continueButtonText: Maybe<Scalars['String']['output']>
  errorButtonText: Maybe<Scalars['String']['output']>
  formResponse: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  registerButtonText: Maybe<Scalars['String']['output']>
  responseStartSubText: Maybe<Scalars['String']['output']>
  responseSubText: Maybe<RichContent>
  responseTitle: Maybe<Scalars['String']['output']>
}

export type GlobalWaitListSignUpWidget = Widget & {
  __typename?: 'GlobalWaitListSignUpWidget'
  buttonText: Maybe<Scalars['String']['output']>
  campaignCode: Maybe<Scalars['ID']['output']>
  enableNameField: Maybe<Scalars['String']['output']>
  enableSignUp: Maybe<Scalars['String']['output']>
  errorReturnUrl: Maybe<Scalars['String']['output']>
  fullNamePlaceholderText: Maybe<Scalars['String']['output']>
  gdprDisclaimerText: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  noAccountReturnUrl: Maybe<Scalars['String']['output']>
  placeholderText: Maybe<Scalars['String']['output']>
  query: Query
  registeredReturnUrl: Maybe<Scalars['String']['output']>
  signUpText: Maybe<Scalars['String']['output']>
  subtitle: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
}

export type GlobalWidgetSirius = Widget & {
  __typename?: 'GlobalWidgetSirius'
  altText: Maybe<Scalars['String']['output']>
  button: Maybe<Scalars['String']['output']>
  highlight: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  image: Maybe<Scalars['String']['output']>
  imagePosition: Maybe<Scalars['String']['output']>
  link: Maybe<Scalars['String']['output']>
  picture: Maybe<GravityPicture>
  query: Query
  subTitle: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  widgetSiriusAltTextVariant: Maybe<Scalars['String']['output']>
  widgetSiriusButtonVariant: Maybe<Scalars['String']['output']>
  widgetSiriusHighlightVariant: Maybe<Scalars['String']['output']>
  widgetSiriusImageVariant: Maybe<Scalars['String']['output']>
  widgetSiriusLinkVariant: Maybe<Scalars['String']['output']>
  widgetSiriusSubTitleVariant: Maybe<Scalars['String']['output']>
  widgetSiriusTitleVariant: Maybe<Scalars['String']['output']>
}

export type GlobalWidgetVega = Widget & {
  __typename?: 'GlobalWidgetVega'
  altTextImg: Maybe<Scalars['String']['output']>
  button: Maybe<Scalars['String']['output']>
  container: Maybe<Scalars['String']['output']>
  containerBg: Maybe<Scalars['String']['output']>
  highlight: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imageDesktop: Maybe<Scalars['String']['output']>
  imageMobile: Maybe<Scalars['String']['output']>
  link: Maybe<Scalars['String']['output']>
  picture: Maybe<GravityPicture>
  query: Query
  subTitle: Maybe<Scalars['String']['output']>
  textAlign: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
}

export type GlobalYoutubeGalleryItem = Widget & {
  __typename?: 'GlobalYoutubeGalleryItem'
  id: Scalars['String']['output']
  query: Query
  title: Maybe<Scalars['String']['output']>
  videoId: Maybe<Scalars['String']['output']>
}

export type GlobalYoutubeGallerySet = Widget & {
  __typename?: 'GlobalYoutubeGallerySet'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
}

export type GravityPicture = {
  __typename?: 'GravityPicture'
  alt: Scalars['String']['output']
  default: Scalars['String']['output']
  sources: Array<Maybe<GravityPictureSource>>
}

export type GravityPictureSource = {
  __typename?: 'GravityPictureSource'
  media: Maybe<Scalars['String']['output']>
  sourceSet: Scalars['String']['output']
  type: Maybe<Scalars['String']['output']>
}

export type HotSpotProducts = {
  __typename?: 'HotSpotProducts'
  brand: Maybe<ProductBlockBrand>
  description: Maybe<Scalars['String']['output']>
  image: Maybe<ProductBlockImage>
  price: Maybe<ProductPrice>
  rangeList: Maybe<Scalars['String']['output']>
  review: Maybe<ProductBlockReview>
  title: Maybe<ProductBlockTitle>
  url: Maybe<Scalars['String']['output']>
}

export type HotSpots = {
  __typename?: 'HotSpots'
  hotSpotProduct: Maybe<HotSpotProducts>
  left: Maybe<Scalars['String']['output']>
  top: Maybe<Scalars['String']['output']>
}

export type Hyperlink = {
  __typename?: 'Hyperlink'
  noFollow: Maybe<Scalars['Boolean']['output']>
  noIndex: Maybe<Scalars['Boolean']['output']>
  openExternally: Maybe<Scalars['Boolean']['output']>
  text: Scalars['String']['output']
  url: Scalars['String']['output']
}

export enum InStockLocation {
  Store = 'STORE',
  Warehouse = 'WAREHOUSE',
}

export type LiveChatWidget = Widget & {
  __typename?: 'LiveChatWidget'
  id: Scalars['String']['output']
  query: Query
}

export type LoyaltyHubBirthdayGift = Widget & {
  __typename?: 'LoyaltyHubBirthdayGift'
  banner: Maybe<Scalars['String']['output']>
  customerLists: Maybe<Scalars['String']['output']>
  description: Maybe<Scalars['String']['output']>
  formInstruction: Maybe<Scalars['String']['output']>
  giftActive: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  modalHeading: Maybe<Scalars['String']['output']>
  query: Query
  title: Maybe<Scalars['String']['output']>
  userNotification: Maybe<Scalars['String']['output']>
}

export type LoyaltyHubTier = Widget & {
  __typename?: 'LoyaltyHubTier'
  banner: Maybe<Scalars['String']['output']>
  bannerAlt: Maybe<Scalars['String']['output']>
  hidden: Maybe<Scalars['String']['output']>
  iconType: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  rewardListText1: Maybe<Scalars['String']['output']>
  rewardListText2: Maybe<Scalars['String']['output']>
  rewardListText3: Maybe<Scalars['String']['output']>
  rewardListText4: Maybe<Scalars['String']['output']>
  rewardListText5: Maybe<Scalars['String']['output']>
  rewardsHeader: Maybe<Scalars['String']['output']>
  textPart1: Maybe<Scalars['String']['output']>
  textPart2: Maybe<Scalars['String']['output']>
  textPart3: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
}

export type MailingList = Widget & {
  __typename?: 'MailingList'
  buttonText: Maybe<Scalars['String']['output']>
  campaignCode: Maybe<Scalars['ID']['output']>
  dropdownAnswer1: Maybe<Scalars['String']['output']>
  dropdownAnswer2: Maybe<Scalars['String']['output']>
  dropdownAnswer3: Maybe<Scalars['String']['output']>
  dropdownAnswer4: Maybe<Scalars['String']['output']>
  dropdownAnswer5: Maybe<Scalars['String']['output']>
  dropdownAnswer6: Maybe<Scalars['String']['output']>
  dropdownAnswer7: Maybe<Scalars['String']['output']>
  dropdownAnswer8: Maybe<Scalars['String']['output']>
  dropdownAnswer9: Maybe<Scalars['String']['output']>
  dropdownAnswer10: Maybe<Scalars['String']['output']>
  dropdownAnswerPlaceholder: Maybe<Scalars['String']['output']>
  dropdownAnswerQuestionText: Maybe<Scalars['String']['output']>
  emailLabelText: Maybe<Scalars['String']['output']>
  emailPlaceholderText: Maybe<Scalars['String']['output']>
  enableDropdownAnswerField: Maybe<Scalars['String']['output']>
  enableNameField: Maybe<Scalars['String']['output']>
  enableSignUp: Maybe<Scalars['String']['output']>
  enablefreeAnswerField: Maybe<Scalars['String']['output']>
  errorReturnUrl: Maybe<Scalars['String']['output']>
  freeAnswerQuestionText: Maybe<Scalars['String']['output']>
  fullNameLabelText: Maybe<Scalars['String']['output']>
  fullNamePlaceholderText: Maybe<Scalars['String']['output']>
  gdprDisclaimerText: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  registeredReturnUrl: Maybe<Scalars['String']['output']>
  signUpText: Maybe<Scalars['String']['output']>
  widgetSubtitle: Maybe<Scalars['String']['output']>
  widgetTitle: Maybe<Scalars['String']['output']>
}

export type MoneyValue = {
  __typename?: 'MoneyValue'
  amount: Scalars['String']['output']
  currency: Currency
  displayValue: Scalars['String']['output']
  scalarValue: Scalars['String']['output']
}

export type MostExpensiveVariantInputs = {
  currency: Currency
  includeLinkedProducts: InputMaybe<Scalars['Boolean']['input']>
  shippingDestination: Country
}

export type MultipleCtaBanner = Widget & {
  __typename?: 'MultipleCTABanner'
  altImageLarge: Maybe<Scalars['String']['output']>
  altLogoPng: Maybe<Scalars['String']['output']>
  bannerURL: Maybe<Scalars['String']['output']>
  contentBoxPosition: Maybe<Scalars['String']['output']>
  contentTheme: Maybe<Scalars['String']['output']>
  ctaOne: Maybe<Scalars['String']['output']>
  ctaOneURL: Maybe<Scalars['String']['output']>
  ctaTwo: Maybe<Scalars['String']['output']>
  ctaTwoURL: Maybe<Scalars['String']['output']>
  headline: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imageLarge: Maybe<Scalars['String']['output']>
  imageMedium: Maybe<Scalars['String']['output']>
  imageSmall: Maybe<Scalars['String']['output']>
  logopngImageBG: Maybe<Scalars['String']['output']>
  query: Query
  subtitle: Maybe<Scalars['String']['output']>
}

export type OptionChoice = {
  __typename?: 'OptionChoice'
  colour: Maybe<Scalars['String']['output']>
  key: Scalars['String']['output']
  optionKey: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type PageAlternateLink = {
  __typename?: 'PageAlternateLink'
  locale: Scalars['String']['output']
  pagePath: Scalars['String']['output']
}

export enum PrefetchRel {
  Prefetch = 'PREFETCH',
  Preload = 'PRELOAD',
}

export type PrefetchTagAttribute = {
  __typename?: 'PrefetchTagAttribute'
  as: Scalars['String']['output']
  fetchPriority: Maybe<FetchPriority>
  href: Scalars['String']['output']
  rel: Maybe<PrefetchRel>
}

export type PriceRange = {
  __typename?: 'PriceRange'
  defaultPrice: Maybe<Scalars['String']['output']>
  maxPrice: Maybe<Scalars['String']['output']>
  minPrice: Maybe<Scalars['String']['output']>
}

export type Product = {
  __typename?: 'Product'
  alternateLinks: Array<AlternateLink>
  brand: Maybe<Brand>
  breadcrumbs: Maybe<Array<Breadcrumb>>
  cheapestVariant: Maybe<ProductVariant>
  cheapestVariantPrice: Maybe<ProductPrice>
  content: Array<ProductContentItem>
  defaultVariant: Maybe<ProductVariant>
  eligibleForWishlist: Scalars['Boolean']['output']
  externalIdentifier: Maybe<Scalars['String']['output']>
  images: Array<ProductImage>
  inStockLocations: Maybe<Array<Maybe<InStockLocation>>>
  inWishlist: Maybe<Scalars['Boolean']['output']>
  isBookable: Maybe<Scalars['Boolean']['output']>
  isCheckStock: Maybe<Scalars['Boolean']['output']>
  isNoCheckStock: Maybe<Scalars['Boolean']['output']>
  isComingSoon: Scalars['Boolean']['output']
  isOrderInStore: Maybe<Scalars['Boolean']['output']>
  leadTime: Maybe<Scalars['Int']['output']>
  linkedOn: Maybe<Scalars['String']['output']>
  marketedSpecialOffer: Maybe<ProductMarketedSpecialOffer>
  mostExpensiveVariant: Maybe<ProductVariant>
  preorder: Scalars['Boolean']['output']
  preorderReleaseDate: Maybe<Scalars['String']['output']>
  reviews: Maybe<ProductReviews>
  sku: Scalars['Int']['output']
  title: Scalars['String']['output']
  url: Scalars['String']['output']
  variants: Array<ProductVariant>
  weightGroups: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type ProductCheapestVariantArgs = {
  inputs: InputMaybe<CheapestVariantInputs>
}

export type ProductCheapestVariantPriceArgs = {
  inputs: InputMaybe<CheapestVariantInputs>
}

export type ProductContentArgs = {
  keys: Array<Scalars['String']['input']>
}

export type ProductImagesArgs = {
  limit?: Scalars['Int']['input']
}

export type ProductMostExpensiveVariantArgs = {
  inputs: InputMaybe<MostExpensiveVariantInputs>
}

export type ProductBlock = {
  __typename?: 'ProductBlock'
  brand: Maybe<ProductBlockBrand>
  externalIdentifier: Maybe<Scalars['String']['output']>
  hoverPicture: GravityPicture
  icons: Maybe<ProductBlockIcons>
  inStock: Maybe<Scalars['Boolean']['output']>
  marketedSpecialOffer: Maybe<ProductBlockMarketedSpecialOffer>
  picture: GravityPicture
  reviews: Maybe<ProductBlockReviews>
  sku: Scalars['Int']['output']
  title: Scalars['String']['output']
  url: Scalars['String']['output']
  outOfGauge: Maybe<Boolean>
  eligibleForHomeDelivery: Maybe<Boolean>
  eligibleForDatedDelivery: Maybe<Boolean>
  eligibleForNextDayDelivery: Maybe<Boolean>
  storeDeliveryEnabled: Maybe<Boolean>
  isCheckStock: Maybe<Boolean>
  isNoCheckStock: Maybe<Boolean>
  weightGroups: Maybe<Array<Maybe<Scalars['String']['output']>>>
  isBookable: Maybe<Scalars['Boolean']['output']>
  isOrderInStore: Maybe<Scalars['Boolean']['output']>
  leadTime: Maybe<Scalars['Int']['output']>
  inStockLocations: Maybe<Array<Maybe<InStockLocation>>>
  clearanceTag: Maybe<Scalars['String']>
  wasPrice: Maybe<Scalars['String']>
}

export type ProductBlockBrand = {
  __typename?: 'ProductBlockBrand'
  imageUrl: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type ProductBlockIcons = {
  __typename?: 'ProductBlockIcons'
  homeDelivery: Scalars['Boolean']['output']
  storeAvailable: Scalars['Boolean']['output']
  storeDelivery: Scalars['Boolean']['output']
}

export type ProductBlockImage = {
  __typename?: 'ProductBlockImage'
  urls: Maybe<ProductImageUrls>
}

export type ProductBlockList = {
  __typename?: 'ProductBlockList'
  correctedQuery: Maybe<Scalars['String']['output']>
  facets: Array<Facet>
  hasMore: Scalars['Boolean']['output']
  productBlocks: Array<ProductBlock>
  total: Scalars['Int']['output']
}

export type ProductBlockListData = {
  __typename?: 'ProductBlockListData'
  imageUrl: Maybe<Scalars['String']['output']>
  inStock: Maybe<Scalars['Boolean']['output']>
  marketedSpecialOffer: Maybe<ProductMarketedSpecialOffer>
  price: Maybe<PriceRange>
  reviews: Maybe<ProductReviews>
  rrp: Maybe<PriceRange>
  sku: Maybe<Scalars['Int']['output']>
  title: Maybe<Scalars['String']['output']>
  url: Maybe<Scalars['String']['output']>
}

export type ProductBlockMarketedSpecialOffer = {
  __typename?: 'ProductBlockMarketedSpecialOffer'
  description: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type ProductBlockReview = {
  __typename?: 'ProductBlockReview'
  screenReaderOnlyText: Maybe<Scalars['String']['output']>
  starRating: Scalars['Float']['output']
}

export type ProductBlockReviews = {
  __typename?: 'ProductBlockReviews'
  numberOfReviews: Scalars['Int']['output']
  starRating: Scalars['Int']['output']
}

export type ProductBlockTitle = {
  __typename?: 'ProductBlockTitle'
  hidelabel: Maybe<Scalars['Boolean']['output']>
  usealternatestyle: Maybe<Scalars['Boolean']['output']>
  value: Scalars['String']['output']
}

export type ProductContentAttachmentValue = {
  __typename?: 'ProductContentAttachmentValue'
  url: Scalars['String']['output']
}

export type ProductContentDateValue = {
  __typename?: 'ProductContentDateValue'
  date: Scalars['Int']['output']
}

export type ProductContentIntListValue = {
  __typename?: 'ProductContentIntListValue'
  intListValue: Array<Scalars['Int']['output']>
}

export type ProductContentIntValue = {
  __typename?: 'ProductContentIntValue'
  intValue: Scalars['Int']['output']
}

export type ProductContentItem = {
  __typename?: 'ProductContentItem'
  key: Scalars['String']['output']
  value: ProductContentValue
}

export type ProductContentRichContentListValue = {
  __typename?: 'ProductContentRichContentListValue'
  richContentListValue: Array<RichContent>
}

export type ProductContentRichContentValue = {
  __typename?: 'ProductContentRichContentValue'
  richContentValue: RichContent
}

export type ProductContentStringListValue = {
  __typename?: 'ProductContentStringListValue'
  stringListValue: Array<Scalars['String']['output']>
}

export type ProductContentStringValue = {
  __typename?: 'ProductContentStringValue'
  stringValue: Scalars['String']['output']
}

export type ProductContentValue =
  | ProductContentAttachmentValue
  | ProductContentDateValue
  | ProductContentIntListValue
  | ProductContentIntValue
  | ProductContentRichContentListValue
  | ProductContentRichContentValue
  | ProductContentStringListValue
  | ProductContentStringValue

export type ProductGallery = {
  __typename?: 'ProductGallery'
  images: Array<ProductGalleryImage>
  prefetches: Maybe<ProductGalleryPrefetch>
  thumbnails: Array<ProductGalleryImage>
  zoom: Array<ProductGalleryImage>
}

export type ProductGalleryImage = {
  __typename?: 'ProductGalleryImage'
  alt: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type ProductGalleryPrefetch = {
  __typename?: 'ProductGalleryPrefetch'
  images: Array<PrefetchTagAttribute>
  zoom: Array<PrefetchTagAttribute>
}

export type ProductIcons = {
  __typename?: 'ProductIcons'
  homeDelivery: Scalars['Boolean']['output']
  storeAvailable: Scalars['Boolean']['output']
  storeDelivery: Scalars['Boolean']['output']
}

export type ProductImage = {
  __typename?: 'ProductImage'
  largeProduct: Maybe<Scalars['String']['output']>
  original: Maybe<Scalars['String']['output']>
  thumbnail: Maybe<Scalars['String']['output']>
  zoom: Maybe<Scalars['String']['output']>
}

export type ProductImageUrls = {
  __typename?: 'ProductImageUrls'
  largeProduct: Maybe<Scalars['String']['output']>
  thumbnail: Maybe<Scalars['String']['output']>
  zoom: Maybe<Scalars['String']['output']>
}

export type ProductList = {
  __typename?: 'ProductList'
  correctedQuery: Maybe<Scalars['String']['output']>
  facets: Array<Facet>
  hasMore: Scalars['Boolean']['output']
  products: Array<Product>
  total: Scalars['Int']['output']
}

export type ProductListDataLayerProduct = {
  __typename?: 'ProductListDataLayerProduct'
  brand: Scalars['String']['output']
  id: Scalars['Int']['output']
  list_name: Scalars['String']['output']
  list_position: Scalars['Int']['output']
  name: Scalars['String']['output']
  price: Scalars['String']['output']
}

export type ProductListInput = {
  barcode: InputMaybe<Scalars['String']['input']>
  concessionCode: InputMaybe<Scalars['String']['input']>
  currency: Currency
  facets: Array<FacetInput>
  limit: Scalars['Int']['input']
  offset: Scalars['Int']['input']
  shippingDestination: Country
  sort: ProductSort
}

export type ProductListWidget = Widget & {
  __typename?: 'ProductListWidget'
  dataLayerProducts: Maybe<Array<Maybe<ProductListDataLayerProduct>>>
  description: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  productBlockList: Maybe<ProductBlockList>
  query: Query
  seoDescription: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
}

export type ProductListWidgetProductBlockListArgs = {
  input: InputMaybe<ProductListInput>
}

export type ProductMarketedSpecialOffer = {
  __typename?: 'ProductMarketedSpecialOffer'
  description: Maybe<RichContent>
  freeGiftProduct: Maybe<ProductVariant>
  landingPageLink: Maybe<Hyperlink>
  onlyDisplayOfferBadge: Maybe<Scalars['Boolean']['output']>
  shouldRemoveScrollLock: Maybe<Scalars['Boolean']['output']>
  title: Maybe<RichContent>
  productsShowcaseList: Maybe<ProductsShowcaseList>
  product: Maybe<Product>
}

export type ProductPrice = {
  __typename?: 'ProductPrice'
  price: Maybe<MoneyValue>
  rrp: Maybe<MoneyValue>
}

export enum ProductRecommendationType {
  CustomersEventuallyBought = 'CUSTOMERS_EVENTUALLY_BOUGHT',
  FrequentlyBoughtTogether = 'FREQUENTLY_BOUGHT_TOGETHER',
  Manual = 'MANUAL',
  Personalised = 'PERSONALISED',
  PostAddToBasket = 'POST_ADD_TO_BASKET',
  SimilarProducts = 'SIMILAR_PRODUCTS',
}

export type ProductRecommenderItem = Widget & {
  __typename?: 'ProductRecommenderItem'
  id: Scalars['String']['output']
  itemFloat: Maybe<Scalars['String']['output']>
  itemSKU: Maybe<Scalars['String']['output']>
  itemTitle: Maybe<Scalars['String']['output']>
  query: Query
}

export type ProductReviews = {
  __typename?: 'ProductReviews'
  averageScore: Scalars['Float']['output']
  maxScore: Scalars['Float']['output']
  total: Scalars['Int']['output']
}

export enum ProductSort {
  DiscountPercentageHighToLow = 'DISCOUNT_PERCENTAGE_HIGH_TO_LOW',
  NameAlphabetically = 'NAME_ALPHABETICALLY',
  NewestToOldest = 'NEWEST_TO_OLDEST',
  Popularity = 'POPULARITY',
  PriceHighToLow = 'PRICE_HIGH_TO_LOW',
  PriceLowToHigh = 'PRICE_LOW_TO_HIGH',
  Relevance = 'RELEVANCE',
}

export type ProductVariant = {
  __typename?: 'ProductVariant'
  availabilityMessage: Scalars['String']['output']
  availabilitySource: AvailabilitySource
  barcode: Maybe<Scalars['String']['output']>
  breadcrumbs: Maybe<Array<Breadcrumb>>
  buyNowPayLaterProviders: Maybe<Array<BuyNowPayLaterProvider>>
  choices: Array<OptionChoice>
  content: Array<ProductContentItem>
  deliveryInformation: Maybe<Scalars['String']['output']>
  earnableLoyaltyPoints: Scalars['Int']['output']
  eligibleForFulfilmentMethods: Maybe<Array<FulfilmentMethod>>
  eligibleForWishlist: Scalars['Boolean']['output']
  externalIdentifier: Maybe<Scalars['String']['output']>
  gallery: Maybe<ProductGallery>
  icons: Maybe<ProductIcons>
  images: Array<ProductImage>
  inStock: Scalars['Boolean']['output']
  inStockLocations: Maybe<Array<Maybe<InStockLocation>>>
  inWishlist: Maybe<Scalars['Boolean']['output']>
  isBookable: Maybe<Scalars['Boolean']['output']>
  isCheckStock: Maybe<Scalars['Boolean']['output']>
  isNoCheckStock: Maybe<Scalars['Boolean']['output']>
  canProductBeStockedChecked: Maybe<Scalars['Boolean']['output']>
  isComingSoon: Scalars['Boolean']['output']
  isOrderInStore: Maybe<Scalars['Boolean']['output']>
  leadTime: Maybe<Scalars['Int']['output']>
  marketedSpecialOffer: Maybe<ProductMarketedSpecialOffer>
  maxPerOrder: Maybe<Scalars['Int']['output']>
  notifyWhenInStockEnabled: Scalars['Boolean']['output']
  price: Maybe<ProductPrice>
  priceRange: Maybe<Scalars['String']['output']>
  product: Maybe<ProductVariantProduct>
  returnsInformation: Maybe<Scalars['String']['output']>
  reviews: Maybe<ProductVariantReviews>
  sku: Scalars['Int']['output']
  subtitle: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  url: Maybe<Scalars['String']['output']>
  weightGroups: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type ProductVariantBuyNowPayLaterProvidersArgs = {
  settings: SessionSettings
}

export type ProductVariantContentArgs = {
  keys: Array<Scalars['String']['input']>
}

export type ProductVariantImagesArgs = {
  limit?: Scalars['Int']['input']
}

export type ProductVariantProduct = {
  __typename?: 'ProductVariantProduct'
  brand: Maybe<Brand>
  content: Array<ProductContentItem>
  sku: Scalars['Int']['output']
  url: Scalars['String']['output']
}

export type ProductVariantProductContentArgs = {
  keys: InputMaybe<Array<Scalars['String']['input']>>
}

export type ProductVariantReviews = {
  __typename?: 'ProductVariantReviews'
  averageScore: Scalars['Float']['output']
  total: Scalars['Int']['output']
}

export type ProductsShowcaseProducts = {
  __typename?: 'ProductsShowcaseProducts'
  productsShowcaseList: Maybe<Array<Maybe<ProductVariant>>>
}

export type ProfileWidget = Widget & {
  __typename?: 'ProfileWidget'
  hasProgressBar: Maybe<Scalars['Boolean']['output']>
  id: Scalars['String']['output']
  isForWidget: Maybe<Scalars['Boolean']['output']>
  profileKey: Maybe<Scalars['String']['output']>
  query: Query
  startLayoutTwoCol: Maybe<Scalars['Boolean']['output']>
  useGridLayout: Maybe<Scalars['Boolean']['output']>
}

export type Query = {
  __typename?: 'Query'
  globalComponentWidgets: Maybe<Array<Maybe<Widget>>>
}

export type RangedFacet = Facet & {
  __typename?: 'RangedFacet'
  facetHeader: Scalars['String']['output']
  facetName: Scalars['String']['output']
  options: Array<RangedFacetOption>
}

export type RangedFacetOption = {
  __typename?: 'RangedFacetOption'
  displayName: Scalars['String']['output']
  /** May be null if the range is unbounded (e.g. "Up to £5") */
  from: Maybe<Scalars['Float']['output']>
  matchedProductCount: Scalars['Int']['output']
  /** May be null if the range is unbounded (e.g. "£50 and up") */
  to: Maybe<Scalars['Float']['output']>
}

export type ResponsiveBuildYourOwnBundle = Widget & {
  __typename?: 'ResponsiveBuildYourOwnBundle'
  banners: Maybe<Array<Maybe<Widget>>>
  bundleSubTitle: Maybe<Scalars['String']['output']>
  expandAllCategories: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  maxProducts: Maybe<Scalars['Int']['output']>
  query: Query
  showBundlePageTitle: Maybe<Scalars['String']['output']>
  showCategoriesList: Maybe<Scalars['String']['output']>
  showInfoButton: Maybe<Scalars['String']['output']>
  showPrices: Maybe<Scalars['String']['output']>
  showProductRRP: Maybe<Scalars['String']['output']>
  showProductReviews: Maybe<Scalars['String']['output']>
  summaryAmount: Maybe<Scalars['String']['output']>
  summaryDisplayType: Maybe<Scalars['String']['output']>
  unlimitedProducts: Maybe<Scalars['String']['output']>
}

export type ResponsiveBuildYourOwnBundleProducts = Widget & {
  __typename?: 'ResponsiveBuildYourOwnBundleProducts'
  categoryTitle: Maybe<Scalars['String']['output']>
  enableQuantitySelector: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  maxProducts: Maybe<Scalars['Int']['output']>
  productList: Maybe<Scalars['String']['output']>
  productsToShow: Maybe<Scalars['Int']['output']>
  query: Query
  /** @deprecated Use the field with type WidgetProductItem, name should be 'paramName'+New */
  skuList: Maybe<Array<Maybe<ProductVariant>>>
  skuListNew: Maybe<Array<Maybe<WidgetProductItem>>>
}

export type ResponsiveComparisonTable = Widget & {
  __typename?: 'ResponsiveComparisonTable'
  buttonText: Maybe<Scalars['String']['output']>
  buttonUrl: Maybe<Scalars['String']['output']>
  comparisonList: Maybe<Scalars['String']['output']>
  disableFeatureTag: Maybe<Scalars['String']['output']>
  featureTag: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imageUrl: Maybe<Scalars['String']['output']>
  moreInfo: Maybe<Scalars['String']['output']>
  query: Query
  subTitle: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
}

export type ResponsiveComparisonTableContainer = Widget & {
  __typename?: 'ResponsiveComparisonTableContainer'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
}

export type ResponsiveProductBlockCarousel = Widget & {
  __typename?: 'ResponsiveProductBlockCarousel'
  displayStandaloneTitle: Maybe<Scalars['String']['output']>
  enableAsiaStyles: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  productBlockList: Maybe<ProductBlockList>
  query: Query
  /** @deprecated Use the field with type WidgetProductItem, name should be 'paramName'+New */
  skuList: Maybe<Array<Maybe<ProductVariant>>>
  skuListNew: Maybe<Array<Maybe<WidgetProductItem>>>
  title: Maybe<Scalars['String']['output']>
  viewAllButtonStyle: Maybe<Scalars['String']['output']>
  viewAllButtonText: Maybe<Scalars['String']['output']>
  viewAllButtonUrl: Maybe<Scalars['String']['output']>
}

export type ResponsiveProductBlockCarouselProductBlockListArgs = {
  input: InputMaybe<ProductListInput>
}

export type ResponsiveProductTabs = Widget & {
  __typename?: 'ResponsiveProductTabs'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
  responsiveProductTabsTitle: Maybe<Scalars['String']['output']>
  tabTitle_1: Maybe<Scalars['String']['output']>
  tabTitle_2: Maybe<Scalars['String']['output']>
  tabTitle_3: Maybe<Scalars['String']['output']>
  url: Maybe<Scalars['String']['output']>
}

export type ResponsiveSetSalon = Widget & {
  __typename?: 'ResponsiveSetSalon'
  banners: Maybe<Array<Maybe<Widget>>>
  beauty: Maybe<Scalars['String']['output']>
  extensions: Maybe<Scalars['String']['output']>
  fridayHours: Maybe<Scalars['String']['output']>
  hair: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  mondayHours: Maybe<Scalars['String']['output']>
  query: Query
  salonBookUrl: Maybe<Scalars['String']['output']>
  salonDescription: Maybe<Scalars['String']['output']>
  salonEmail: Maybe<Scalars['String']['output']>
  salonTel: Maybe<Scalars['String']['output']>
  salonTitle: Maybe<Scalars['String']['output']>
  saturdayHours: Maybe<Scalars['String']['output']>
  socialUrl: Maybe<Scalars['String']['output']>
  sprayTan: Maybe<Scalars['String']['output']>
  sundayHours: Maybe<Scalars['String']['output']>
  thursdayHours: Maybe<Scalars['String']['output']>
  tuesdayHours: Maybe<Scalars['String']['output']>
  wednesdayHours: Maybe<Scalars['String']['output']>
}

export type ResponsiveSetSalonWithSlides = Widget & {
  __typename?: 'ResponsiveSetSalonWithSlides'
  beauty: Maybe<Scalars['String']['output']>
  extensions: Maybe<Scalars['String']['output']>
  fridayHours: Maybe<Scalars['String']['output']>
  hair: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  mondayHours: Maybe<Scalars['String']['output']>
  query: Query
  salonBookUrl: Maybe<Scalars['String']['output']>
  salonDescription: Maybe<Scalars['String']['output']>
  salonEmail: Maybe<Scalars['String']['output']>
  salonTel: Maybe<Scalars['String']['output']>
  salonTitle: Maybe<Scalars['String']['output']>
  saturdayHours: Maybe<Scalars['String']['output']>
  sliderImage1: Maybe<Scalars['String']['output']>
  sliderImage1Alt: Maybe<Scalars['String']['output']>
  sliderImage2: Maybe<Scalars['String']['output']>
  sliderImage2Alt: Maybe<Scalars['String']['output']>
  sliderImage3: Maybe<Scalars['String']['output']>
  sliderImage3Alt: Maybe<Scalars['String']['output']>
  socialUrl: Maybe<Scalars['String']['output']>
  sprayTan: Maybe<Scalars['String']['output']>
  sundayHours: Maybe<Scalars['String']['output']>
  thursdayHours: Maybe<Scalars['String']['output']>
  tuesdayHours: Maybe<Scalars['String']['output']>
  wednesdayHours: Maybe<Scalars['String']['output']>
}

export type ResponsiveSliderSet = Widget & {
  __typename?: 'ResponsiveSliderSet'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  isAutoSlideOn: Maybe<Scalars['String']['output']>
  isBulletNavigationHidden: Maybe<Scalars['String']['output']>
  isHeightVariable: Maybe<Scalars['String']['output']>
  query: Query
  slideDuration: Maybe<Scalars['Int']['output']>
}

export type ResponsiveSuccessStoriesWidgetContainer = Widget & {
  __typename?: 'ResponsiveSuccessStoriesWidgetContainer'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
}

export type ResponsiveSuccessStoryWidget = Widget & {
  __typename?: 'ResponsiveSuccessStoryWidget'
  caption: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imageAfterAltText: Maybe<Scalars['String']['output']>
  imageAfterUrl: Maybe<Scalars['String']['output']>
  imageAltText: Maybe<Scalars['String']['output']>
  imageUrl: Maybe<Scalars['String']['output']>
  linkUrl: Maybe<Scalars['String']['output']>
  profileCta: Maybe<Scalars['String']['output']>
  profileName: Maybe<Scalars['String']['output']>
  query: Query
  roundelTitle: Maybe<Scalars['String']['output']>
  weightLossStyle: Maybe<Scalars['String']['output']>
  weightLost: Maybe<Scalars['String']['output']>
}

export type ResponsiveTwoItemComparisonContainer = Widget & {
  __typename?: 'ResponsiveTwoItemComparisonContainer'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
  title1: Maybe<Scalars['String']['output']>
  title2: Maybe<Scalars['String']['output']>
}

export type ResponsiveTwoItemComparisonRow = Widget & {
  __typename?: 'ResponsiveTwoItemComparisonRow'
  firstItem: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  secondItem: Maybe<Scalars['String']['output']>
  valueToCompare: Maybe<Scalars['String']['output']>
  valueToCopmare: Maybe<Scalars['String']['output']>
}

export type ResponsiveUspBar = Widget & {
  __typename?: 'ResponsiveUSPBar'
  callIcon: Maybe<Scalars['String']['output']>
  callLink: Maybe<Scalars['String']['output']>
  callText: Maybe<Scalars['String']['output']>
  checkmarkLink: Maybe<Scalars['String']['output']>
  checkmarkText: Maybe<Scalars['String']['output']>
  clickAndCollectLink: Maybe<Scalars['String']['output']>
  clickAndCollectText: Maybe<Scalars['String']['output']>
  countDownLink: Maybe<Scalars['String']['output']>
  countDownText: Maybe<Scalars['String']['output']>
  deliveryLink: Maybe<Scalars['String']['output']>
  deliveryText: Maybe<Scalars['String']['output']>
  emailLink: Maybe<Scalars['String']['output']>
  emailText: Maybe<Scalars['String']['output']>
  fastTrackLink: Maybe<Scalars['String']['output']>
  fastTrackText: Maybe<Scalars['String']['output']>
  fridayCutoff: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  internationalDeliveryLink: Maybe<Scalars['String']['output']>
  internationalDeliveryText: Maybe<Scalars['String']['output']>
  mondayCutoff: Maybe<Scalars['String']['output']>
  qualityLink: Maybe<Scalars['String']['output']>
  qualityText: Maybe<Scalars['String']['output']>
  query: Query
  returnsLink: Maybe<Scalars['String']['output']>
  returnsText: Maybe<Scalars['String']['output']>
  rewardPointsLink: Maybe<Scalars['String']['output']>
  rewardPointsText: Maybe<Scalars['String']['output']>
  saturdayCutoff: Maybe<Scalars['String']['output']>
  storeLink: Maybe<Scalars['String']['output']>
  storeText: Maybe<Scalars['String']['output']>
  sundayCutoff: Maybe<Scalars['String']['output']>
  thursdayCutoff: Maybe<Scalars['String']['output']>
  timezoneOffset: Maybe<Scalars['String']['output']>
  trustPilotLink: Maybe<Scalars['String']['output']>
  trustPilotText: Maybe<Scalars['String']['output']>
  tuesdayCutoff: Maybe<Scalars['String']['output']>
  wednesdayCutoff: Maybe<Scalars['String']['output']>
}

export type ResponsiveUspBarCustomisable = Widget & {
  __typename?: 'ResponsiveUSPBarCustomisable'
  calendarLink: Maybe<Scalars['String']['output']>
  calendarPosition: Maybe<Scalars['Int']['output']>
  calendarText: Maybe<Scalars['String']['output']>
  callIcon: Maybe<Scalars['String']['output']>
  callLink: Maybe<Scalars['String']['output']>
  callPosition: Maybe<Scalars['Int']['output']>
  callText: Maybe<Scalars['String']['output']>
  checkmarkLink: Maybe<Scalars['String']['output']>
  checkmarkPosition: Maybe<Scalars['Int']['output']>
  checkmarkText: Maybe<Scalars['String']['output']>
  clickAndCollectLink: Maybe<Scalars['String']['output']>
  clickAndCollectPosition: Maybe<Scalars['Int']['output']>
  clickAndCollectText: Maybe<Scalars['String']['output']>
  countdownLink: Maybe<Scalars['String']['output']>
  countdownPosition: Maybe<Scalars['Int']['output']>
  countdownText: Maybe<Scalars['String']['output']>
  deliveryLink: Maybe<Scalars['String']['output']>
  deliveryPosition: Maybe<Scalars['Int']['output']>
  deliveryText: Maybe<Scalars['String']['output']>
  emailLink: Maybe<Scalars['String']['output']>
  emailPosition: Maybe<Scalars['Int']['output']>
  emailText: Maybe<Scalars['String']['output']>
  fastTrackLink: Maybe<Scalars['String']['output']>
  fastTrackPosition: Maybe<Scalars['Int']['output']>
  fastTrackText: Maybe<Scalars['String']['output']>
  fridayCutoff: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  internationalDeliveryLink: Maybe<Scalars['String']['output']>
  internationalDeliveryPosition: Maybe<Scalars['Int']['output']>
  internationalDeliveryText: Maybe<Scalars['String']['output']>
  mondayCutoff: Maybe<Scalars['String']['output']>
  qualityLink: Maybe<Scalars['String']['output']>
  qualityPosition: Maybe<Scalars['Int']['output']>
  qualityText: Maybe<Scalars['String']['output']>
  query: Query
  rewardPointsLink: Maybe<Scalars['String']['output']>
  rewardPointsPosition: Maybe<Scalars['Int']['output']>
  rewardPointsText: Maybe<Scalars['String']['output']>
  saturdayCutoff: Maybe<Scalars['String']['output']>
  storeLink: Maybe<Scalars['String']['output']>
  storePosition: Maybe<Scalars['Int']['output']>
  storeText: Maybe<Scalars['String']['output']>
  sundayCutoff: Maybe<Scalars['String']['output']>
  thursdayCutoff: Maybe<Scalars['String']['output']>
  timezoneOffset: Maybe<Scalars['String']['output']>
  trustPilotLink: Maybe<Scalars['String']['output']>
  trustPilotPosition: Maybe<Scalars['Int']['output']>
  trustPilotText: Maybe<Scalars['String']['output']>
  tuesdayCutoff: Maybe<Scalars['String']['output']>
  wednesdayCutoff: Maybe<Scalars['String']['output']>
}

export enum ReviewSort {
  HighestToLowestRating = 'HIGHEST_TO_LOWEST_RATING',
  MostToLeastPositiveVotes = 'MOST_TO_LEAST_POSITIVE_VOTES',
  NewestToOldest = 'NEWEST_TO_OLDEST',
}

export type ReviewsFilterInput = {
  scores: Array<Scalars['Int']['input']>
}

export type RichContent = {
  __typename?: 'RichContent'
  content: Array<RichContentItem>
}

export type RichContentContentArgs = {
  filter: InputMaybe<Array<RichContentType>>
}

export type RichContentItem = {
  __typename?: 'RichContentItem'
  content: Scalars['String']['output']
  type: RichContentType
}

export enum RichContentType {
  Html = 'HTML',
  Markdown = 'MARKDOWN',
}

export type SectionPeekProducts = {
  __typename?: 'SectionPeekProducts'
  sectionPeekProducts: Maybe<Array<Maybe<ProductBlockListData>>>
  sectionPeekWidgetProductBlockList: Maybe<Array<Maybe<ProductBlockListData>>>
}

export type SeoProductCategory = Widget & {
  __typename?: 'SeoProductCategory'
  buttonStyle: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  productCategoryName: Maybe<Scalars['String']['output']>
  productCategoryUrl: Maybe<Scalars['String']['output']>
  query: Query
}

export type SeoProductCategorySet = Widget & {
  __typename?: 'SeoProductCategorySet'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
  showDiscoverTag: Maybe<Scalars['String']['output']>
  showMore: Maybe<Scalars['String']['output']>
}

export type SessionSettings = {
  __typename?: 'SessionSettings'
  currency: Maybe<Currency>
  shippingDestination: Maybe<Country>
}

export type ShopTheLookHotSpot = Widget & {
  __typename?: 'ShopTheLookHotSpot'
  /** @deprecated Use the field with type WidgetProductItem, name should be 'paramName'+New */
  SKU: Maybe<ProductVariant>
  SKUNew: Maybe<WidgetProductItem>
  hiddenMd: Maybe<Scalars['String']['output']>
  hiddenSm: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  itemLeft: Maybe<Scalars['String']['output']>
  itemLeftMd: Maybe<Scalars['String']['output']>
  itemLeftSm: Maybe<Scalars['String']['output']>
  itemTop: Maybe<Scalars['String']['output']>
  itemTopMd: Maybe<Scalars['String']['output']>
  itemTopSm: Maybe<Scalars['String']['output']>
  productDescription: Maybe<Scalars['String']['output']>
  query: Query
  rangeList: Maybe<Scalars['String']['output']>
}

export type SimpleFacet = Facet & {
  __typename?: 'SimpleFacet'
  facetHeader: Scalars['String']['output']
  facetName: Scalars['String']['output']
  options: Array<SimpleFacetOption>
}

export type SimpleFacetOption = {
  __typename?: 'SimpleFacetOption'
  displayName: Scalars['String']['output']
  matchedProductCount: Scalars['Int']['output']
  optionName: Scalars['String']['output']
}

export type SimpleTextReadMore = Widget & {
  __typename?: 'SimpleTextReadMore'
  id: Scalars['String']['output']
  query: Query
  simpleTextReadMore_maxHeight: Maybe<Scalars['Int']['output']>
  simpleTextReadMore_text: Maybe<RichContent>
  simpleTextReadMore_textAlign: Maybe<Scalars['String']['output']>
  simpleTextReadMore_title: Maybe<Scalars['String']['output']>
  simpleTextReadMore_titleIsH1: Maybe<Scalars['Boolean']['output']>
}

export type SliderFacet = Facet & {
  __typename?: 'SliderFacet'
  facetHeader: Scalars['String']['output']
  facetName: Scalars['String']['output']
  maxValue: Scalars['Float']['output']
  minValue: Scalars['Float']['output']
}

export type TopBrandsWidget = Widget & {
  __typename?: 'TopBrandsWidget'
  BrandEightLogoPath: Maybe<Scalars['String']['output']>
  BrandEightName: Maybe<Scalars['String']['output']>
  BrandFiveLogoPath: Maybe<Scalars['String']['output']>
  BrandFiveName: Maybe<Scalars['String']['output']>
  BrandFourLogoPath: Maybe<Scalars['String']['output']>
  BrandFourName: Maybe<Scalars['String']['output']>
  BrandOneLogoPath: Maybe<Scalars['String']['output']>
  BrandOneName: Maybe<Scalars['String']['output']>
  BrandSevenLogoPath: Maybe<Scalars['String']['output']>
  BrandSevenName: Maybe<Scalars['String']['output']>
  BrandSixLogoPath: Maybe<Scalars['String']['output']>
  BrandSixName: Maybe<Scalars['String']['output']>
  BrandTabTitle: Maybe<Scalars['String']['output']>
  BrandThreeLogoPath: Maybe<Scalars['String']['output']>
  BrandThreeName: Maybe<Scalars['String']['output']>
  BrandTwoLogoPath: Maybe<Scalars['String']['output']>
  BrandTwoName: Maybe<Scalars['String']['output']>
  altTextBrandEightLogo: Maybe<Scalars['String']['output']>
  altTextBrandFiveLogo: Maybe<Scalars['String']['output']>
  altTextBrandFourLogo: Maybe<Scalars['String']['output']>
  altTextBrandOneLogo: Maybe<Scalars['String']['output']>
  altTextBrandSevenLogo: Maybe<Scalars['String']['output']>
  altTextBrandSixLogo: Maybe<Scalars['String']['output']>
  altTextBrandThreeLogo: Maybe<Scalars['String']['output']>
  altTextBrandTwoLogo: Maybe<Scalars['String']['output']>
  altTextFeaturedImage: Maybe<Scalars['String']['output']>
  altTextFeaturedLogo: Maybe<Scalars['String']['output']>
  featuredBrandName: Maybe<Scalars['String']['output']>
  featuredBrandPageLink: Maybe<Scalars['String']['output']>
  featuredBrandPageLinkName: Maybe<Scalars['String']['output']>
  featuredBrandText: Maybe<Scalars['String']['output']>
  featuredImagePath: Maybe<Scalars['String']['output']>
  featuredLogoPath: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
}

export type TopProductCategory = Widget & {
  __typename?: 'TopProductCategory'
  buttonStyle: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  topProductCategoryName: Maybe<Scalars['String']['output']>
  topProductCategoryUrl: Maybe<Scalars['String']['output']>
}

export type TopProductCategorySet = Widget & {
  __typename?: 'TopProductCategorySet'
  DiscoverTitle: Maybe<Scalars['String']['output']>
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
  showDiscoverTag: Maybe<Scalars['String']['output']>
  showMore: Maybe<Scalars['String']['output']>
}

export type TrustPilotCarouselWidget = Widget & {
  __typename?: 'TrustPilotCarouselWidget'
  businessId: Maybe<Scalars['String']['output']>
  dataStars: Maybe<Scalars['String']['output']>
  height: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  languageCode: Maybe<Scalars['String']['output']>
  locale: Maybe<Scalars['String']['output']>
  query: Query
  templateId: Maybe<Scalars['String']['output']>
  theme: Maybe<Scalars['String']['output']>
  url: Maybe<Scalars['String']['output']>
  width: Maybe<Scalars['String']['output']>
}

export type TrustPilotWidget = Widget & {
  __typename?: 'TrustPilotWidget'
  businessId: Maybe<Scalars['String']['output']>
  height: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  isCarousel: Maybe<Scalars['String']['output']>
  languageCode: Maybe<Scalars['String']['output']>
  locale: Maybe<Scalars['String']['output']>
  query: Query
  templateId: Maybe<Scalars['String']['output']>
  theme: Maybe<Scalars['String']['output']>
  url: Maybe<Scalars['String']['output']>
  width: Maybe<Scalars['String']['output']>
}

export type VariantOption = {
  __typename?: 'VariantOption'
  choices: Array<OptionChoice>
  key: Scalars['String']['output']
  localizedKey: Maybe<Scalars['String']['output']>
}

export type VariantOptions = {
  currency: Currency
  shippingDestination: Country
}

export type VoucherCodesWidget = Widget & {
  __typename?: 'VoucherCodesWidget'
  id: Scalars['String']['output']
  query: Query
}

export type Widget = {
  id: Scalars['String']['output']
}

export type WidgetProductItem = {
  __typename?: 'WidgetProductItem'
  product: Maybe<Product>
  productVariant: Maybe<ProductVariant>
}

export type AsymmetricGrid = Widget & {
  __typename?: 'asymmetricGrid'
  altTextImgOne: Maybe<Scalars['String']['output']>
  altTextImgTwo: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imageOnePath: Maybe<Scalars['String']['output']>
  imageOneSubtitle: Maybe<Scalars['String']['output']>
  imageTwoPath: Maybe<Scalars['String']['output']>
  imageTwoSubtitle: Maybe<Scalars['String']['output']>
  linkOne: Maybe<Scalars['String']['output']>
  linkTwo: Maybe<Scalars['String']['output']>
  query: Query
  title: Maybe<Scalars['String']['output']>
  widthImageOne: Maybe<Scalars['Int']['output']>
  widthImageOneMobile: Maybe<Scalars['Int']['output']>
  widthImageTwo: Maybe<Scalars['Int']['output']>
  widthImageTwoMobile: Maybe<Scalars['Int']['output']>
}

export type Buildyourownbundle = Widget & {
  __typename?: 'buildyourownbundle'
  banners: Maybe<Array<Maybe<Widget>>>
  bundlePageTitle: Maybe<Scalars['String']['output']>
  bundleSubTitle: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  maxProducts: Maybe<Scalars['String']['output']>
  packSummary: Maybe<Scalars['String']['output']>
  query: Query
  showPrices: Maybe<Scalars['String']['output']>
  summaryAmount: Maybe<Scalars['String']['output']>
}

export type ButtonLink = Widget & {
  __typename?: 'buttonLink'
  id: Scalars['String']['output']
  link: Maybe<Scalars['String']['output']>
  query: Query
  style: Maybe<Scalars['String']['output']>
  text: Maybe<Scalars['String']['output']>
}

export type CategoryItemCard = Widget & {
  __typename?: 'categoryItemCard'
  altTextitem: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  itemCTA: Maybe<Scalars['String']['output']>
  itemDescription: Maybe<Scalars['String']['output']>
  itemImagePath: Maybe<Scalars['String']['output']>
  itemTitle: Maybe<Scalars['String']['output']>
  itemUrl: Maybe<Scalars['String']['output']>
  picture: Maybe<GravityPicture>
  query: Query
  textAlignment: Maybe<Scalars['String']['output']>
}

export type CategoryItemCardWithTextOverlay = Widget & {
  __typename?: 'categoryItemCardWithTextOverlay'
  altTextitem: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  itemCTA: Maybe<Scalars['String']['output']>
  itemDescription: Maybe<Scalars['String']['output']>
  itemImagePath: Maybe<Scalars['String']['output']>
  itemTitle: Maybe<Scalars['String']['output']>
  itemUrl: Maybe<Scalars['String']['output']>
  query: Query
  textAlignment: Maybe<Scalars['String']['output']>
}

export type CoverageCalculator = Widget & {
  __typename?: 'coverageCalculator'
  additionalInfoDisclaimerText: Maybe<Scalars['String']['output']>
  additionalInfoText: Maybe<RichContent>
  additionalInfoTitle: Maybe<Scalars['String']['output']>
  buyButtonLink: Maybe<Scalars['String']['output']>
  calculatorSubtitle: Maybe<Scalars['String']['output']>
  calculatorTitle: Maybe<Scalars['String']['output']>
  calculatorType: Maybe<Scalars['String']['output']>
  excludeAreaHelpText: Maybe<RichContent>
  id: Scalars['String']['output']
  instructionsText: Maybe<RichContent>
  instructionsTitle: Maybe<Scalars['String']['output']>
  paintCoatsHelpText: Maybe<RichContent>
  paintCoverage: Maybe<Scalars['String']['output']>
  query: Query
  wallpaperRollLength: Maybe<Scalars['String']['output']>
  wallpaperRollWidth: Maybe<Scalars['String']['output']>
}

export type EightLinkButtonWidget = Widget & {
  __typename?: 'eightLinkButtonWidget'
  buttonTextEight: Maybe<Scalars['String']['output']>
  buttonTextFive: Maybe<Scalars['String']['output']>
  buttonTextFour: Maybe<Scalars['String']['output']>
  buttonTextOne: Maybe<Scalars['String']['output']>
  buttonTextSeven: Maybe<Scalars['String']['output']>
  buttonTextSix: Maybe<Scalars['String']['output']>
  buttonTextThree: Maybe<Scalars['String']['output']>
  buttonTextTwo: Maybe<Scalars['String']['output']>
  buttonUrlEight: Maybe<Scalars['String']['output']>
  buttonUrlFive: Maybe<Scalars['String']['output']>
  buttonUrlFour: Maybe<Scalars['String']['output']>
  buttonUrlOne: Maybe<Scalars['String']['output']>
  buttonUrlSeven: Maybe<Scalars['String']['output']>
  buttonUrlSix: Maybe<Scalars['String']['output']>
  buttonUrlThree: Maybe<Scalars['String']['output']>
  buttonUrlTwo: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  title: Maybe<Scalars['String']['output']>
  titleAlign: Maybe<Scalars['String']['output']>
}

export type Fouritemwindowproductslider = Widget & {
  __typename?: 'fouritemwindowproductslider'
  ctaLink: Maybe<Scalars['String']['output']>
  ctaText: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  productCount: Maybe<Scalars['Int']['output']>
  productList: Maybe<Scalars['String']['output']>
  query: Query
  subtitle: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
}

export type GeneralIframe = Widget & {
  __typename?: 'generalIframe'
  id: Scalars['String']['output']
  iframeSource: Maybe<Scalars['String']['output']>
  query: Query
}

export type GeneralQuoteBanner = Widget & {
  __typename?: 'generalQuoteBanner'
  ctaText: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  subtitle: Maybe<Scalars['String']['output']>
  textLink: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
}

export type ImageSelectCard = Widget & {
  __typename?: 'imageSelectCard'
  ImageInformationText: Maybe<Scalars['String']['output']>
  altTextImage: Maybe<Scalars['String']['output']>
  altTextThumbnail: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  itemImageLargePath: Maybe<Scalars['String']['output']>
  itemImagePath: Maybe<Scalars['String']['output']>
  itemImageSmallPath: Maybe<Scalars['String']['output']>
  query: Query
  thumbnailImagePath: Maybe<Scalars['String']['output']>
}

export type ImageSelectSlider = Widget & {
  __typename?: 'imageSelectSlider'
  altTextLogoImage: Maybe<Scalars['String']['output']>
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  logoImagePath: Maybe<Scalars['String']['output']>
  query: Query
  titleText: Maybe<Scalars['String']['output']>
}

export type ImprovedSearchBestSellers = Widget & {
  __typename?: 'improvedSearchBestSellers'
  id: Scalars['String']['output']
  productId1: Maybe<Scalars['String']['output']>
  productId2: Maybe<Scalars['String']['output']>
  productId3: Maybe<Scalars['String']['output']>
  productId4: Maybe<Scalars['String']['output']>
  query: Query
  widgetTitle: Maybe<Scalars['String']['output']>
}

export type KitBuilder = Widget & {
  __typename?: 'kitBuilder'
  id: Scalars['String']['output']
  kitBuilderDistributorId: Maybe<Scalars['String']['output']>
  kitBuilderKey: Maybe<Scalars['String']['output']>
  query: Query
}

export type LoyaltyRewardsList = Widget & {
  __typename?: 'loyaltyRewardsList'
  id: Scalars['String']['output']
  listItem1: Maybe<Scalars['String']['output']>
  listItem2: Maybe<Scalars['String']['output']>
  listItem3: Maybe<Scalars['String']['output']>
  listItem4: Maybe<Scalars['String']['output']>
  listItem5: Maybe<Scalars['String']['output']>
  listItem6: Maybe<Scalars['String']['output']>
  listItem7: Maybe<Scalars['String']['output']>
  listItem8: Maybe<Scalars['String']['output']>
  query: Query
  title: Maybe<Scalars['String']['output']>
}

export type LoyaltyWelcomeMessage = Widget & {
  __typename?: 'loyaltyWelcomeMessage'
  accountCreationTextPart1: Maybe<Scalars['String']['output']>
  accountCreationTextPart2: Maybe<Scalars['String']['output']>
  heading: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imageAltText: Maybe<Scalars['String']['output']>
  imagePath: Maybe<Scalars['String']['output']>
  profileCompletionTextPart1: Maybe<Scalars['String']['output']>
  profileCompletionTextPart2: Maybe<Scalars['String']['output']>
  query: Query
  subHeading: Maybe<Scalars['String']['output']>
}

export type MultiCategoryCardSet = Widget & {
  __typename?: 'multiCategoryCardSet'
  backgroundColour: Maybe<Scalars['String']['output']>
  banners: Maybe<Array<Maybe<Widget>>>
  columnsNumber: Maybe<Scalars['Int']['output']>
  id: Scalars['String']['output']
  multiCategoryCardSet_CTAText: Maybe<Scalars['String']['output']>
  query: Query
  widgetSubtitle: Maybe<Scalars['String']['output']>
  widgetTitle: Maybe<Scalars['String']['output']>
}

export type MultiCategoryCardSetV2 = Widget & {
  __typename?: 'multiCategoryCardSetV2'
  alternativeItemCardDesign: Maybe<Scalars['Boolean']['output']>
  backgroundColour: Maybe<Scalars['String']['output']>
  banners: Maybe<Array<Maybe<Widget>>>
  columnsNumber: Maybe<Scalars['Int']['output']>
  id: Scalars['String']['output']
  marginStyle: Maybe<Scalars['String']['output']>
  mobileColumns: Maybe<Scalars['Int']['output']>
  query: Query
  scrollable: Maybe<Scalars['Boolean']['output']>
  stackCardsOnMobile: Maybe<Scalars['Boolean']['output']>
  theme: Maybe<Scalars['String']['output']>
  widgetSubtitle: Maybe<Scalars['String']['output']>
  widgetTitle: Maybe<Scalars['String']['output']>
}

export type ObsessVr = Widget & {
  __typename?: 'obsessVR'
  id: Scalars['String']['output']
  ingetgrityHash: Maybe<Scalars['String']['output']>
  obsessVRclient: Maybe<Scalars['String']['output']>
  obsessVRhideLogo: Maybe<Scalars['Boolean']['output']>
  obsessVRstore: Maybe<Scalars['String']['output']>
  query: Query
  storeId: Maybe<Scalars['String']['output']>
}

export type ParcelLabWidget = Widget & {
  __typename?: 'parcelLabWidget'
  id: Scalars['String']['output']
  parcelLabUserId: Maybe<Scalars['Int']['output']>
  query: Query
  showSearchForm: Maybe<Scalars['String']['output']>
  showZipCodeInput: Maybe<Scalars['String']['output']>
}

export type ProductsShowcaseList = {
  __typename?: 'productsShowcaseList'
  products: Maybe<ProductsShowcaseProducts>
}

export type Promoproductslider = Widget & {
  __typename?: 'promoproductslider'
  featuredImage: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imageURL: Maybe<Scalars['String']['output']>
  productCount: Maybe<Scalars['Int']['output']>
  productList: Maybe<ProductList>
  query: Query
  widgetSubtitle: Maybe<Scalars['String']['output']>
  widgetTitle: Maybe<Scalars['String']['output']>
}

export type PropositionBar = Widget & {
  __typename?: 'propositionBar'
  id: Scalars['String']['output']
  query: Query
  textFive: Maybe<Scalars['String']['output']>
  textFour: Maybe<Scalars['String']['output']>
  textOne: Maybe<Scalars['String']['output']>
  textSix: Maybe<Scalars['String']['output']>
  textThree: Maybe<Scalars['String']['output']>
  textTwo: Maybe<Scalars['String']['output']>
}

export type PropositionBarIncorrect = Widget & {
  __typename?: 'propositionBarIncorrect'
  id: Scalars['String']['output']
  query: Query
}

export type ProvenanceBrandHeader = Widget & {
  __typename?: 'provenanceBrandHeader'
  brand: Maybe<Scalars['String']['output']>
  brandId: Maybe<Scalars['String']['output']>
  button2Text: Maybe<Scalars['String']['output']>
  button2Url: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  itemAlign: Maybe<Scalars['String']['output']>
  itemAlt: Maybe<Scalars['String']['output']>
  itemButton: Maybe<Scalars['String']['output']>
  itemImage: Maybe<Scalars['String']['output']>
  itemImageSmall: Maybe<Scalars['String']['output']>
  itemText: Maybe<RichContent>
  itemTitle: Maybe<Scalars['String']['output']>
  itemURL: Maybe<Scalars['String']['output']>
  query: Query
  textAlign: Maybe<Scalars['String']['output']>
  transcript: Maybe<RichContent>
  videoTitle: Maybe<Scalars['String']['output']>
  videoUrl: Maybe<Scalars['String']['output']>
}

export type QubitHomePageRecs = Widget & {
  __typename?: 'qubitHomePageRecs'
  FloatOfProducts: Maybe<Scalars['Int']['output']>
  id: Scalars['String']['output']
  placementId: Maybe<Scalars['String']['output']>
  productList: Maybe<ProductList>
  query: Query
  theme: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
  titleAlign: Maybe<Scalars['String']['output']>
  url: Maybe<Scalars['String']['output']>
}

export type RevieveWidget = Widget & {
  __typename?: 'revieveWidget'
  id: Scalars['String']['output']
  query: Query
}

export type ShadeFinder = Widget & {
  __typename?: 'shadeFinder'
  buttonText: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  openOnLoad: Maybe<Scalars['String']['output']>
  query: Query
  text: Maybe<RichContent>
  title: Maybe<Scalars['String']['output']>
  widgetAlignment: Maybe<Scalars['String']['output']>
}

export type ShopTheLook = Widget & {
  __typename?: 'shopTheLook'
  altImageLarge: Maybe<Scalars['String']['output']>
  banners: Maybe<Array<Maybe<Widget>>>
  hotSpotVariants: Maybe<HotSpots>
  id: Scalars['String']['output']
  imageLarge: Maybe<Scalars['String']['output']>
  imageMedium: Maybe<Scalars['String']['output']>
  imageSmall: Maybe<Scalars['String']['output']>
  itemDescription: Maybe<Scalars['String']['output']>
  itemTitle: Maybe<Scalars['String']['output']>
  query: Query
}

export type SimpleCta = Widget & {
  __typename?: 'simpleCTA'
  CTAStyle: Maybe<Scalars['String']['output']>
  CTAText: Maybe<Scalars['String']['output']>
  CTAUrl: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  secondCTAStyle: Maybe<Scalars['String']['output']>
  secondCTAText: Maybe<Scalars['String']['output']>
  secondCTAUrl: Maybe<Scalars['String']['output']>
  simpleCTABackgroundColour: Maybe<Scalars['String']['output']>
  simpleCTABackgroundIsFullWidth: Maybe<Scalars['Boolean']['output']>
  title: Maybe<Scalars['String']['output']>
}

export type SimpleDivider = Widget & {
  __typename?: 'simpleDivider'
  id: Scalars['String']['output']
  marginBottom: Maybe<Scalars['Int']['output']>
  marginTop: Maybe<Scalars['Int']['output']>
  maxWidth: Maybe<Scalars['Int']['output']>
  overrideStyles: Maybe<Scalars['Boolean']['output']>
  query: Query
}

export type SimpleTextWidgetSet = Widget & {
  __typename?: 'simpleTextWidgetSet'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
}

export type SimpleTitleWidget = Widget & {
  __typename?: 'simpleTitleWidget'
  additionalSubtitleStyles: Maybe<Scalars['String']['output']>
  additionalTitleStyles: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  query: Query
  subtitle: Maybe<Scalars['String']['output']>
  text: Maybe<Scalars['String']['output']>
  textAlign: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
}

export type Simpletextwidget = Widget & {
  __typename?: 'simpletextwidget'
  displayOnDesktopOnly: Maybe<Scalars['Boolean']['output']>
  id: Scalars['String']['output']
  query: Query
  text: Maybe<RichContent>
  textAlign: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
}

export type Simpletextwidgetwithh1 = Widget & {
  __typename?: 'simpletextwidgetwithh1'
  displayOnDesktopOnly: Maybe<Scalars['Boolean']['output']>
  id: Scalars['String']['output']
  query: Query
  text: Maybe<RichContent>
  textAlign: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
}

export type SponsoredProducts = Widget & {
  __typename?: 'sponsoredProducts'
  /** @deprecated Use the field with type WidgetProductItem, name should be 'paramName'+New */
  ProductOne: Maybe<ProductVariant>
  ProductOneNew: Maybe<WidgetProductItem>
  /** @deprecated Use the field with type WidgetProductItem, name should be 'paramName'+New */
  ProductTwo: Maybe<ProductVariant>
  ProductTwoNew: Maybe<WidgetProductItem>
  altLogoPng: Maybe<Scalars['String']['output']>
  contentTheme: Maybe<Scalars['String']['output']>
  ctaOne: Maybe<Scalars['String']['output']>
  ctaOneAriaLabel: Maybe<Scalars['String']['output']>
  ctaOneURL: Maybe<Scalars['String']['output']>
  headline: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  logopngImageBG: Maybe<Scalars['String']['output']>
  logopngWhiteBG: Maybe<Scalars['String']['output']>
  query: Query
  text: Maybe<Scalars['String']['output']>
  useH1: Maybe<Scalars['String']['output']>
}

export type SponsoredProductsCriteoHomepage = Widget & {
  __typename?: 'sponsoredProductsCriteoHomepage'
  id: Scalars['String']['output']
  query: Query
}

export type SponsoredProductsNew = Widget & {
  __typename?: 'sponsoredProductsNew'
  id: Scalars['String']['output']
  query: Query
  widgetVersion: Maybe<Scalars['String']['output']>
}

export type StoryStreamWidget = Widget & {
  __typename?: 'storyStreamWidget'
  id: Scalars['String']['output']
  integrityHash: Maybe<Scalars['String']['output']>
  layoutClass: Maybe<Scalars['String']['output']>
  query: Query
  storyStreamId: Maybe<Scalars['String']['output']>
}

export type SubscribeAndSaveInformationModal = Widget & {
  __typename?: 'subscribeAndSaveInformationModal'
  id: Scalars['String']['output']
  imageAltText: Maybe<Scalars['String']['output']>
  imageLarge: Maybe<Scalars['String']['output']>
  imageSmall: Maybe<Scalars['String']['output']>
  modalContent: Maybe<RichContent>
  modalTitle: Maybe<Scalars['String']['output']>
  query: Query
}

export type SwatchSelectSlider = Widget & {
  __typename?: 'swatchSelectSlider'
  altTextImageFour: Maybe<Scalars['String']['output']>
  altTextImageOne: Maybe<Scalars['String']['output']>
  altTextImageThree: Maybe<Scalars['String']['output']>
  altTextImageTwo: Maybe<Scalars['String']['output']>
  altTextLogoImage: Maybe<Scalars['String']['output']>
  altTextThumbnailImageFour: Maybe<Scalars['String']['output']>
  altTextThumbnailImageOne: Maybe<Scalars['String']['output']>
  altTextThumbnailImageThree: Maybe<Scalars['String']['output']>
  altTextThumbnailImageTwo: Maybe<Scalars['String']['output']>
  count: Maybe<Scalars['String']['output']>
  cta: Maybe<Scalars['String']['output']>
  ctaLink: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  imageFourLink: Maybe<Scalars['String']['output']>
  imageFourPath: Maybe<Scalars['String']['output']>
  imageOneLink: Maybe<Scalars['String']['output']>
  imageOnePath: Maybe<Scalars['String']['output']>
  imageThreeLink: Maybe<Scalars['String']['output']>
  imageThreePath: Maybe<Scalars['String']['output']>
  imageTwoLink: Maybe<Scalars['String']['output']>
  imageTwoPath: Maybe<Scalars['String']['output']>
  info: Maybe<Scalars['String']['output']>
  link: Maybe<Scalars['String']['output']>
  linkText: Maybe<Scalars['String']['output']>
  logoImagePath: Maybe<Scalars['String']['output']>
  parentWidgetLink: Maybe<Scalars['String']['output']>
  query: Query
  thumbnailImageFourPath: Maybe<Scalars['String']['output']>
  thumbnailImageOnePath: Maybe<Scalars['String']['output']>
  thumbnailImageThreePath: Maybe<Scalars['String']['output']>
  thumbnailImageTwoPath: Maybe<Scalars['String']['output']>
  titleFour: Maybe<Scalars['String']['output']>
  titleOne: Maybe<Scalars['String']['output']>
  titleThree: Maybe<Scalars['String']['output']>
  titleTwo: Maybe<Scalars['String']['output']>
}

export type SwatchSelectSliderSet = Widget & {
  __typename?: 'swatchSelectSliderSet'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
}

export type TrustReinforcementContainer = Widget & {
  __typename?: 'trustReinforcementContainer'
  banners: Maybe<Array<Maybe<Widget>>>
  id: Scalars['String']['output']
  query: Query
  showStockInformation: Maybe<Scalars['Boolean']['output']>
}

export type TrustReinforcementSection = Widget & {
  __typename?: 'trustReinforcementSection'
  icon: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  modalBody: Maybe<RichContent>
  modalTitle: Maybe<Scalars['String']['output']>
  query: Query
  subtitle: Maybe<Scalars['String']['output']>
  title: Maybe<Scalars['String']['output']>
}

export type YotiAgeVerification = Widget & {
  __typename?: 'yotiAgeVerification'
  id: Scalars['String']['output']
  query: Query
  yotiDisplayText: Maybe<Scalars['String']['output']>
}

export type YotiCancelFrame = Widget & {
  __typename?: 'yotiCancelFrame'
  id: Scalars['String']['output']
  query: Query
}
